/* eslint-disable no-continue */
/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-bitwise */
/* eslint-disable prefer-arrow-callback */
/* eslint-disable new-parens */

import { TZobj as timezones } from '@sendible/localization';
import * as pdfjs from 'pdfjs-dist/build/pdf.mjs';
import {
  reportErrorToFaro,
  validators,
} from '@sendible/common';
import UploadMediaModel from '../../models/media/UploadMediaModel.js';
import QueueModel from '../../models/queue/QueueModel.js';
import UserCollection from '../../collections/users/UserCollection.js';
import CampaignCollection from '../../collections/manage/CampaignCollection.js';
import MediaLibraryCollection from '../../collections/media/MediaLibraryCollection.js';
import ServiceCollection from '../../collections/services/ServiceCollection.js';
import InboxServiceCollection from '../../collections/services/InboxServiceCollection.js';
import LibraryCollection from '../../collections/manage/LibraryCollection.js';
import PermissionProfileCollection from '../../collections/manage/PermissionProfileCollection.js';
import ListsCollection from '../../collections/lists/ListsCollection.js';
import ServiceTypesCollection from '../../collections/services/ServiceTypesCollection.js';
import NotificationView from '../../views/common/NotificationView.js';
import UserAlertView from '../../views/common/UserAlertView.js';
import CacheManager from '../../views/common/CacheManager.js';
import SocialProfileCollection from '../../collections/manage/SocialProfileCollection.js';
import ObjectUtils from '../utils/object-utils.js';
import UrlUtils from '../utils/url-utils.js';

import optionTemplate from '../../../templates/common/optionTemplate.html';

const notificationView = new NotificationView();
const userAlertView = new UserAlertView();
const o = $({});

/* SHIMS for older browsers
   * From https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/keys
   * used for giving IE8 and other older browser the same functonality as modern browsers
   * Added: btoa (base64 encoding)
   *
   */

/* File Reader "polyfill" T. Boyd
   *
   * Create a Flash file picker implementation that returns a base64 value (for an image) and the associated file information
   * Creates a button in place of an input for opening the file picker
   *
   * To use:
   *      FlashFileReader.setButton("object-id", callback)
   *      <object id="object-id"></object>
   *
   * Returns:
   *      {data: base64 string, name: filename, lastModified: last modified data, size: file size}
   *
   */
/**
   * @author Zakir Tariverdiev
   * @class animatedGifDetect
   * @description
   * GIF file reader that checks whether GIF image is animated, or not.
   * Uses information gathered from the website below:
   * http://www.matthewflickinger.com/lab/whatsinagif/bits_and_bytes.asp
   */
(function (window) {
  // Prevent redefinition of animatedGifDetect
  if (typeof window.animatedGifDetect !== 'undefined') {
    return;
  }

  const HEADER_LEN = 6; // offset bytes for the header section
  const LOGICAL_SCREEN_DESC_LEN = 7; // offset bytes for logical screen description section
  let fileReader; // we'll re-use this object
  const callbackConfig = {
    animatedCb: null,
    nonAnimatedCb: null,
    context: window,
  };

  // fileReader.addEventListener('load', _checkForAnimation, false);
  /**
       * @method _checkForAnimation
       * @private
       * @memberof animatedGifDetect
       * @description Looks for the "delay" bytes in the GIF file. These bytes will be set to non 0 value
       * if the GIF file is animated.
       */
  function _checkForAnimation() {
    const buffer = fileReader.result;
    // Start from last 4 bytes of the Logical Screen Descriptor
    const dv = new DataView(buffer, HEADER_LEN + LOGICAL_SCREEN_DESC_LEN - 3);
    let offset = 0;
    const globalColorTable = dv.getUint8(0); // aka packet byte
    let globalColorTableSize = 0;

    // check first bit, if 0, then we don't have a Global Color Table
    if (globalColorTable & 0x80) {
      // grab the last 3 bits, to calculate the global color table size -> RGB * 2^(N+1)
      // N is the value in the last 3 bits.
      globalColorTableSize = 3 * 2 ** ((globalColorTable & 0x7) + 1);
    }

    // move on to the Graphics Control Extension
    offset = 3 + globalColorTableSize;

    const extensionIntroducer = dv.getUint8(offset);
    const graphicsConrolLabel = dv.getUint8(offset + 1);
    let delayTime = 0;

    // Graphics Control Extension section is where GIF animation data is stored
    // First 2 bytes must be 0x21 and 0xF9
    if ((extensionIntroducer & 0x21) && (graphicsConrolLabel & 0xF9)) {
      // skip to the 2 bytes with the delay time
      delayTime = dv.getUint16(offset + 4);
    }

    if (delayTime && typeof callbackConfig.animatedCb === 'function') {
      callbackConfig.animatedCb.apply(callbackConfig.context || window);
    } else if (!delayTime && typeof callbackConfig.nonAnimatedCb === 'function') {
      callbackConfig.nonAnimatedCb.apply(callbackConfig.context || window);
    }
  }
  /**
       * @method process
       * @memberof animatedGifDetect
       * @description Converts the provided GIF file into array buffer and checks whether it is
       * animated, or not.
       * @param {File} gifFile - GIF file to check for animation
       * @param {function} animatedCb - callback to fire if GIF is animated
       * @param {function} [nonAnimatedCb] - callback to fire if GIF is not animated
       * @param {object} [context] - context for the callbacks. Defaults to window
       */
  function process(gifFile, animatedCb, nonAnimatedCb, context) {
    fileReader = new FileReader(); // we'll re-use this object
    fileReader.addEventListener('load', _checkForAnimation, false);

    if (gifFile) {
      callbackConfig.animatedCb = animatedCb;
      callbackConfig.nonAnimatedCb = nonAnimatedCb;
      callbackConfig.context = context;
      fileReader.readAsArrayBuffer(gifFile);
    }
  }

  window.animatedGifDetect = {
    process,
  };
}(window));

/* Cross domain cors fix. T. Boyd
   *
   * Replaces the XDomainRequest method with one that allows CORS in IE8/9 to work
   *
   * References
   *      http://bergie.iki.fi/VIE/docs/2.0.0/src/xdr.js.html
   *      https://gist.github.com/michaelcox/2655118
   *      http://api.brain-map.org/examples/doc/scatter/javascripts/jquery.ie.cors.js.html
   *
   */

if (window.XDomainRequest) {
  jQuery.ajaxTransport((s) => {
    if (s.crossDomain && s.async) {
      if (s.timeout) {
        s.xdrTimeout = s.timeout;
        delete s.timeout;
      }
      let xdr;
      return {
        send(_, complete) {
          function callback(status, statusText, responses, responseHeaders) {
            xdr.onload = xdr.onerror = xdr.ontimeout = jQuery.noop;
            xdr = undefined;
            complete(status, statusText, responses, responseHeaders);
          }
          xdr = new window.XDomainRequest();
          xdr.onload = function () {
            callback(200, 'OK', {
              text: xdr.responseText,
            }, `Content-Type: ${xdr.contentType}`);
          };
          xdr.onerror = function () {
            callback(404, 'Not Found');
          };
          xdr.onprogress = function () {};
          xdr.ontimeout = function () {
            callback(0, 'timeout');
          };
          xdr.timeout = s.xdrTimeout || Number.MAX_VALUE;
          xdr.open(s.type, s.url);
          xdr.send((s.hasContent && s.data) || null);
        },
        abort() {
          if (xdr) {
            xdr.onerror = function () {};
            xdr.abort();
          }
        },
      };
    }
  });
}

if (!Object.keys) {
  Object.keys = (function () {
    const { hasOwnProperty } = Object.prototype;
    const hasDontEnumBug = !({
      toString: null,
    }).propertyIsEnumerable('toString');
    const dontEnums = [
      'toString',
      'toLocaleString',
      'valueOf',
      'hasOwnProperty',
      'isPrototypeOf',
      'propertyIsEnumerable',
      'constructor',
    ];
    const dontEnumsLength = dontEnums.length;

    return function (obj) {
      if (typeof obj !== 'object' && (typeof obj !== 'function' || obj === null)) {
        throw new TypeError('Object.keys called on non-object');
      }

      const result = [];
      let prop; let
        i;

      for (prop in obj) {
        if (hasOwnProperty.call(obj, prop)) {
          result.push(prop);
        }
      }

      if (hasDontEnumBug) {
        for (i = 0; i < dontEnumsLength; i++) {
          if (hasOwnProperty.call(obj, dontEnums[i])) {
            result.push(dontEnums[i]);
          }
        }
      }
      return result;
    };
  }());
}

/* toBlob polyfill
   *
   * Enables Safari on Mac to save to blob
   *
   * References
   *
   *        https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob
   *
   */

if (!HTMLCanvasElement.prototype.toBlob) {
  Object.defineProperty(HTMLCanvasElement.prototype, 'toBlob', {
    value(callback, type, quality) {
      const binStr = atob(this.toDataURL(type, quality).split(',')[1]);
      const len = binStr.length;
      const arr = new Uint8Array(len);

      for (let i = 0; i < len; i++) {
        arr[i] = binStr.charCodeAt(i);
      }

      callback(new Blob([arr], { type: type || 'image/png' }));
    },
  });
}

HTMLTextAreaElement.prototype.insertAtCaret = function (text) {
  text = text || '';
  if (document.selection) {
    // IE
    this.focus();
    const sel = document.selection.createRange();
    sel.text = text;
  } else if (this.selectionStart || this.selectionStart === 0) {
    // Others
    const startPos = this.selectionStart;
    const endPos = this.selectionEnd;
    this.value = this.value.substring(0, startPos)
              + text
              + this.value.substring(endPos, this.value.length);
    this.selectionStart = startPos + text.length;
    this.selectionEnd = startPos + text.length;
  } else {
    this.value += text;
  }
};

/* prepend polyfill
   *
   * Enables IE11 to use node.prepend
   *
   * References
   *
   *        https://developer.mozilla.org/en-US/docs/Web/API/ParentNode/prepend
   *
   */

(function (arr) {
  arr.forEach((item) => {
    if (item.hasOwnProperty('prepend')) {
      return;
    }
    Object.defineProperty(item, 'prepend', {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function prepend(...args) {
        const argArr = Array.prototype.slice.call(args);
        const docFrag = document.createDocumentFragment();

        argArr.forEach((argItem) => {
          const isNode = argItem instanceof Node;
          docFrag.appendChild(isNode ? argItem : document.createTextNode(String(argItem)));
        });

        this.insertBefore(docFrag, this.firstChild);
      },
    });
  });
}([Element.prototype, Document.prototype, DocumentFragment.prototype]));

window.Utils = {
  subscribe: o.on.bind(o),
  unsubscribe: o.off.bind(o),
  publish: o.trigger.bind(o),
  timeUnits: {},
  openWindows: [],
  appTabHasFocus: true,
  fileExtensionRegex: /\.\w{2,10}($|\?)/,
  maxCharactersData: {
      'twitter': 280,
      'linkedin': 3000,
      'instagram': 2200,
      'instagramhashtags': 30,
      'facebook': 63206,
      'pinterest': 500,
      'tiktok': 2200,
      'threads': 500,
      'bluesky': 300,
      'googlemybusinesslocation': 1500,
      'youtube': 5000
  },
  encodeTypes: [
    'UTF-8',
    'ASCII',
    'UTF-16',
    'Windows-1250',
    'Windows-1251',
    'Windows-1252',
    'Windows-1253',
    'Windows-1254',
    'Windows-1255',
    'Windows-1256',
    'Windows-1257',
    'Windows-1258',
    'ISO 8859-1',
    'ISO 8859-2',
    'ISO 8859-3',
    'ISO 8859-4',
    'ISO 8859-5',
    'ISO 8859-6',
    'ISO 8859-7',
    'ISO 8859-8',
    'ISO 8859-9',
    'ISO 8859-10',
    'ISO 8859-11',
    'ISO 8859-12',
    'ISO 8859-13',
    'ISO 8859-14',
    'ISO 8859-15',
    'ISO 8859-16',
  ],

  regexFindMentionTagsInString: /(?:^|[^\S])(@[a-zA-Z0-9_.]+)/gim,

  isMobile: (window.innerWidth <= 800 && window.innerHeight <= 600),

  init() {
    const userAgent = navigator.userAgent.toLowerCase();

    window.Utils.timeUnits = {
      D: window.lookup('day'),
      H: window.lookup('hour'),
      W: window.lookup('week'),
      M: window.lookup('month'),
      Y: window.lookup('year'),
    };

    window.Utils.$body = $('body');
    window.Utils.$html = $('html');

    window.Utils.isEdge = userAgent.indexOf('edge') > -1;
    window.Utils.isChrome = (userAgent.indexOf('chrome') > -1) && !window.Utils.isEdge;
    window.Utils.isIE = window.ActiveXObject || 'ActiveXObject' in window;
    window.Utils.isIE8 = window.Utils.$html.hasClass('ie8');
    window.Utils.isFirefox = userAgent.indexOf('firefox') > -1;
    window.Utils.isSafari = userAgent.indexOf('safari') > -1;
    window.Utils.isMacOs = userAgent.indexOf('Mac') > -1;

    window.Utils.handleModalsShown();

    if (window.Utils.isIE) {
      window.Utils.$html.addClass('is-ie');
    }

    if (window.Utils.isMacOs) {
      window.Utils.$html.addClass('mac-os');
    }

    timezones.primeTimezoneCache(null);

    Backbone.listenTo(Backbone, 'primeTimeZones', timezones.primeTimezoneCache);

    Backbone.listenTo(Backbone, 'close-all-modals', window.Utils.closeAllOpenModals);
    // create emoji method
    window.Utils.processEmojiText = window.Utils.createEmojiMethod();

    /* isRequired
                  checks for the presence of "required" on the jQuery Validator settings rule object, interprets this and returns a booleon
                  returns true by default (always required unless specified)
          */
    const isRequired = function () {
      const { that } = this;
      const $element = $(this.element);
      const identifier = $element.attr('name') || $element.attr('id') || $element.attr('class') || false;
      let required = true;
      let rules;

      if (identifier !== false) {
        rules = that.settings.rules[identifier];

        if (typeof rules !== 'undefined') {
          if (rules.hasOwnProperty('required') && rules.required === true) {
            required = true;
          } else if (rules.hasOwnProperty('required') && rules.required === false) {
            required = false;
          }
        }
      }

      return required;
    };

    $.validator.addMethod('URL_only', function (value, element) {
      const val = ($.trim(value)).toLowerCase();
      let valid = window.Utils.urlValidate(val, element);
      const required = _.bind(isRequired, { that: this, element })();

      if (required === false && val === '') {
        valid = true;
      }

      return valid;
    }, window.lookup('Please enter a valid URL.'));

    $.validator.addMethod('mailto_and_URL', function (value, element) {
      const val = ($.trim(value)).toLowerCase();
      let valid = window.Utils.urlValidate(val, element);
      const required = _.bind(isRequired, { that: this, element })();

      if (val.match(window.globalObject.mailtoRegex)) {
        valid = true;
      }

      if (required === false && val === '') {
        valid = true;
      }

      return valid;
    }, window.lookup('Please enter a valid URL or email.'));

    $.validator.addMethod('urlFieldNoHTTPWorking', (value) => {
      const val = ($.trim(value)).toLowerCase();
      const urlMailRegEx = /^[^http://www.|https://www.|http://|https://|www.]?[0-9a-zA-Z]{2,}\.[0-9a-zA-Z]{2,63}(\.[0-9a-zA-Z]{2,63})?$/;

      return val === '' || urlMailRegEx.test(val);
    }, window.lookup('Please enter a valid URL.'));

    $.validator.addMethod('mailto_placeholder_and_URL', function (value, element) {
      const val = ($.trim(value)).toLowerCase();
      let valid = window.Utils.urlValidate(val, element);
      const required = _.bind(isRequired, { that: this, element })();

      if (val.match(window.globalObject.mailtoRegex)) {
        valid = true;
      } else if (val.match(/^\$[\w+\d]+/)) {
        valid = true;
      }

      if (required === false && val === '') {
        valid = true;
      }

      return valid;
    }, window.lookup('Please enter a valid URL, email or placeholder.'));

    $.validator.addMethod(
      'time',
      (value) => value === '' || (/^([01]?[0-9]|2[0-3]):[0-5][0-9] ?[am,pm]*$/).test(value),
      window.lookup('Please enter a valid time.'),
    );

    $.validator.addMethod(
      'telephone',
      (value) => value === '' || (/^\d{7,}$/).test(value.replace(/[\s()+\-.]|ext/gi, '')),
      window.lookup('Please enter a valid telephone number.'),
    );

    $.validator.addMethod(
      'wordCount',
      (value, element, params) => {
        const count = window.Utils.getWordCount(value);
        if (count >= params[0]) {
          return true;
        }
      },
      jQuery.format(window.lookup('Please enter {0} words.')),
    );

    $.validator.addMethod('check_date_of_birth', (value) => {
      // age must be correct format and no older than 100 and no future dates
      if (value == '') return true;

      const Bdate = moment(value, 'YYYY/MM/DD');
      const currDate = new Date();
      const isAfter = Bdate.isAfter(moment(currDate).subtract('years', 100));
      const isBefore = Bdate.isBefore(currDate, 'year');

      return isAfter && isBefore && (/^\d{4}\/\d{2}\/\d{1,2}$/).test(value);
    }, window.lookup('Please enter a valid birthday.'));

    $.validator.addMethod('validColor', (value) => value.match(/^#[a-fA-F0-9]{3,6}$/i) !== null, window.lookup('Please enter a valid color.'));

    $.validator.addMethod('alphaNumericRegex', (value) => {
      if (/[^a-zA-Z0-9]/gi.test(value) === true) {
        return false;
      }

      if (/[^a-zA-Z0-9]/gi.test(value) === false) {
        return true;
      }

      return false;
    }, window.lookup('Please enter only text or numbers.'));

    $.validator.addMethod('alphaNumeric', (value) => value === '' || (/^[\w &]+$/).test($.trim(value)), window.lookup('Please enter only text or numbers.'));

    $.validator.addMethod('multipleEmailsComma', (value, element) => _.every($(element).val().split(','), (email) => window.globalObject.emailRegex.test(email.trim())), window.lookup('Please enter a valid email address. Separate multiple emails with a comma.'));

    $.validator.addMethod('email', (value) => value === '' || value.match(window.globalObject.emailRegex), window.lookup('Please enter a valid email.'));

    this.addStrongPasswordJqueryValidation();

    window.globalObject.fileTypeExtensions = {
      imageFileExtensions: _.flatten(_.without(window.globalObject.fileTypes.imageFileTypes, true)),
      pdfFileExtensions: _.flatten(_.without(window.globalObject.fileTypes.pdfFileTypes, true)),
      videoFileTypes: _.flatten(_.without(window.globalObject.fileTypes.videoFileTypes, true)),
    };

    window.globalObject.allFileTypeExtensions = _.flatten(_.map(window.globalObject.fileTypes, (fileTypes) => _.flatten(_.without(fileTypes, true))));
    window.globalObject.allFileTypeExtensionsWithoutVideo = _.flatten(_.map(window.globalObject.fileTypes, (fileTypes, key) => {
      if (key !== 'videoFileTypes') {
        return _.flatten(_.without(fileTypes, true));
      }
    }));
    window.globalObject.allFileTypeExtensionsImageAndVideo = _.flatten(_.map(window.globalObject.fileTypes, (fileTypes, key) => {
      if (key == 'videoFileTypes' || key == 'imageFileTypes') {
        return _.flatten(_.without(fileTypes, true));
      }
    })).filter((item) => item !== undefined);

    window.Utils.$window = $(window);

    window.Utils.subscribe('onUserScrolled', window.Utils.handleLargeModal);

    window.Utils.$window.resize(window.Utils.handleLargeModal);

    // adds an instance of "CacheManagementView" to utils
    this.cacheManager = new CacheManager();

    // Script that detects mobile browser
    // http://detectmobilebrowsers.com/
    window.Utils.isMobile = (function (a) {
      if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0, 4))) {
        return true;
      }
      return false;
    }(navigator.userAgent || navigator.vendor || window.opera, 'http://detectmobilebrowser.com/mobile'));

    $(window).on('blur focus', function (e) {
      const prevType = $(this).data('prevType');

      if (prevType != e.type) {
        switch (e.type) {
          case 'blur':
            window.Utils.appTabHasFocus = false;
            break;
          case 'focus':
            window.Utils.appTabHasFocus = true;
            break;
          default:
        }
      }

      $(this).data('prevType', e.type);
    });

    // pdf library setup
    pdfjs.GlobalWorkerOptions.workerSrc = 'https://sendible-public.s3.us-east-1.amazonaws.com/modules/pdf.worker.mjs';

    this.primeLIPageAccountID();
  },

  addStrongPasswordJqueryValidation() {
    $.validator.addMethod('strong_password', (value) => {
      const validation = validators.validatePassword(value);

      return !validation.isInvalid;
    }, (value, element) => {
      const password = $(element).val();

      let errorMessage = '';
      const validation = validators.validatePassword(password);

      if (!validation.hasMinLength) {
        errorMessage += `<li>${validators.minLengthMessage}</li>`;
      }
      if (!validation.hasLowerCase) {
        errorMessage += `<li>${validators.lowercaseMessage}</li>`;
      }
      if (!validation.hasUpperCase) {
        errorMessage += `<li>${validators.uppercaseMessage}</li>`;
      }
      if (!validation.hasNumber) {
        errorMessage += `<li>${validators.numberMessage}</li>`;
      }
      if (!validation.hasSpecialChar) {
        errorMessage += `<li>${validators.specialCharMessage}</li>`;
      }

      if (errorMessage !== '') {
        return `The password must meet these requirements:
                <ul>${errorMessage}</ul>`;
      }

      return errorMessage;
    });
  },

  handlePDFDIsplay(fileUrl, $canvas, $pdfIconImage, scale = 0.18) {
    const loadingTask = pdfjs.getDocument(fileUrl);
    loadingTask.promise.then((pdf) => {
      const pageNumber = 1;
      pdf.getPage(pageNumber).then((page) => {
        $pdfIconImage.addClass('hide');
        $canvas.removeClass('hide');

        const viewport = page.getViewport({ scale });

        // Prepare canvas using PDF page dimensions
        const canvas = $canvas.get(0);
        const context = canvas.getContext('2d');
        canvas.height = viewport.height;
        canvas.width = viewport.width;

        // Render PDF page into canvas context
        const renderContext = {
          canvasContext: context,
          viewport,
        };
        page.render(renderContext);
      });
    }, (reason) => {
      // PDF loading error
      $pdfIconImage.removeClass('hide');
      $canvas.addClass('hide');

      // If browser cannot display pdf
      // then revert to pdf icon
      $pdfIconImage
        .on('error', function () {
          $pdfIconImage.attr('src', '/s3_assets/images/pdf.png');
        })
        .attr('src', fileUrl);
    });
  },

  setLIPageAccountID(services) {
    if (!services
        || !services.length
        || !services[0]?.account_type
        || !services[0]?.account_id
    ) {
      return;
    }

    const LI_COMPANY_PAGE = 'Linkedin company page';
    const liPage = _.find(services, (service) => service.account_type === LI_COMPANY_PAGE);

    if (liPage?.account_id) {
      window.Utils.liCompanyPageAccountID = liPage?.account_id;
    }
  },

  primeLIPageAccountID() {
    window.Utils.liCompanyPageAccountID = null;

    //  NOTE: If user is not logged in then don't run this
    const checkDetails = loginContext.getDefaultLoginDetails();
    if (!checkDetails.user_id) {
      return;
    }

    (new ServiceCollection).fetch({
      type: 'social',
      success: (collection) => {
        const services = collection.toJSON();
        window.Utils.setLIPageAccountID(services);
      },
    });
  },

  convertCollectionToStreamCSV($msgBlocks) {
    const csv = [];
    let $block;
    let link;
    let postMessage;

    // add header to csv array
    csv.push(`${window.lookup('Date')},${window.lookup('Name')},${window.lookup('Message')},${window.lookup('Link')}`);

    $msgBlocks.each(function () {
      $block = $(this);
      postMessage = window.Utils.replaceAll($.trim($block.find('.post-body').text()), '"', '""');
      postMessage = window.Utils.replaceAll(postMessage, '\r', '');
      postMessage = window.Utils.replaceAll(postMessage, '\n', '');
      link = $block.data('msg-link') ? `"${$block.data('msg-link')}"` : '" "';

      csv.push(`"${$block.find('.media-heading small').text()}","${$block.find('.media-heading a').text()}","${postMessage}",${
        link}`);
    });

    return {
      payload: csv.join('\r\n'),
      numberOfRows: csv.length,
    };
  },

  resetCache() {
    window.Utils.removeAllCookies();

    if (window.localStorage) {
      window.localStorage.clear();
      Backbone.trigger('user-account:changed');
      Backbone.trigger('primeTimeZones');
    }
  },

  removeAllCookies() {
    document.cookie.split(';').forEach((c) => {
      if (c.indexOf('proxysrv=') === -1) {
        document.cookie = c.replace(/^ +/, '').replace(/=.*/, `=;expires=${new Date().toUTCString()};path=/`);
      }
    });
  },

  updateDropdownLayout($el) {
    const viewPortHeight = parseInt(window.Utils.$window.height(), 10);
    const availableGap = viewPortHeight - (parseInt($el.offset().top, 10) + parseInt($el.height(), 10));

    // add small-screen class if height is below 700
    if (availableGap < 189) {
      $el.addClass('small-screen');
    } else {
      $el.removeClass('small-screen');
    }

    if (availableGap < 60) {
      $('.modal-footer .dropdown').removeClass('dropdown').addClass('dropup');
    } else {
      $('.modal-footer .dropup').removeClass('dropup').addClass('dropdown');
    }
  },

  urlValidate(val, element) {
    const valAddedHTTP = `https://${val}`;
    let valid = false;
    let $element;

    if (element) {
      $element = $(element);
    }

    if (val.match(window.globalObject.urlRegex)) {
      valid = true;
    } else if (valAddedHTTP.match(window.globalObject.urlRegex)) {
      valid = true;
      if (element) {
        $element.val(valAddedHTTP);
      }
    }

    return valid;
  },

  blobToFile(theBlob, fileName) {
    theBlob.lastModifiedDate = new Date();
    theBlob.name = fileName;
    return theBlob;
  },

  isPDF(file) {
    const PDF = 'pdf';
    const PDFTYPE = 'application/pdf';

    if (typeof file === 'string' && file.includes(`.${PDF}`)) {
      return true;
    }

    return file?.extension === PDF || file?.type === PDFTYPE || file?.file_type === PDFTYPE || file?.name?.includes(`.${PDF}`) || file?.file_name?.includes(`.${PDF}`);
  },

  includesPDFs(files) {
    if (!files || !files.length) {
      return false;
    }

    for (let i = 0; i < files.length && files[i]; i++) {
      if (this.isPDF(files[i])) {
        return true;
      }
    }

    return false;
  },

  getFirstPDF(files) {
    if (!files || !files.length) {
      return false;
    }

    for (let i = 0; i < files.length && files[i]; i++) {
      if (this.isPDF(files[i])) {
        return files[i];
      }
    }

    return false;
  },

  urlHasExtension(url) {
    const extRegex = this.fileExtensionRegex;

    return url && url.length ? extRegex.test(url) : false;
  },
  // this is used in old media system for running media validations, to be removed in favour of new media system
  getFileExtensionFromFile(file) {
    let extension;

    if (!file.file_url && !file.type) {
      extension = '';
    }

    if (file?.extension) {
      extension = file.extension;
    } else if (file.fileName && Utils.urlHasExtension(file.fileName)) {
      extension = window.Utils.getFileExtension(file.fileName);
    } else if (file.file_url && Utils.urlHasExtension(file.file_url)) {
      extension = window.Utils.getFileExtension(file.file_url);
    } else if (file.type) {
      extension = window.Utils.getFileExtension(file.type);
    } else if (file.name && Utils.urlHasExtension(file.name)) {
      extension = window.Utils.getFileExtension(file.name);
    }

    if (extension === 'video/quicktime' || extension === 'quicktime' || extension === 'qt') {
      extension = 'mov';
    }

    return extension;
  },
  // only used by getFileExtensionFromFile, DO NOT USE anywhere else
  getFileExtension(file_url) {
    let arExtension;
    let arMatchedExtension;
    let strExtension;
    const extRegex = this.fileExtensionRegex;

    if (file_url && (
      file_url.indexOf('text/') === 0
              || file_url.indexOf('image/') === 0
              || file_url.indexOf('audio/') === 0
              || file_url.indexOf('video/') === 0
              || file_url.indexOf('application/') === 0)
    ) {
      arExtension = file_url.split('/');
    } else {
      arMatchedExtension = file_url.match(extRegex);
      if (arMatchedExtension && arMatchedExtension.length) {
        arExtension = arMatchedExtension[0];
      }

      arExtension = !!arExtension ? arExtension.split('.') : [''];
    }

    if (arExtension.length > 0) {
      strExtension = arExtension.pop();

      if (strExtension.includes('?')) {
        strExtension = strExtension.substr(0, strExtension.indexOf('?'));
      }

      return strExtension;
    }

    return false;
  },
  getMediaUrl(file) {
    let isVideo;
    if(file.tw_media){
       isVideo = this.getExtensionTypeFromTWMedia(file.tw_media) === 'video'
    }else{
       isVideo = Utils.isVideo(file.link_url)
    }
    return isVideo ? file.link_url : file.file_url
  },
  isVideo(strName) {
    return this.getExtensionFromUrl(strName) === 'video'
  },
  getExtensionFromUrl(url) {
    const allExtensions = Object.values(window.globalObject.allFileTypeExtensions);
    const matchedExtension = allExtensions.find(ext =>
      new RegExp(`\\${ext}(\\?|#|$)`).test(url)
    );

    if (!matchedExtension) return 'unknown';

    const { imageFileExtensions, pdfFileExtensions, videoFileTypes } = window.globalObject.fileTypeExtensions;

    if (imageFileExtensions.includes(matchedExtension)) {
      return 'image';
    }

    if (pdfFileExtensions.includes(matchedExtension)) {
      return 'pdf';
    }

    if (videoFileTypes.includes(matchedExtension)) {
      return 'video';
    }

    return 'unknown'; 
  },
  getExtensionTypeFromTWMedia(tw_media) {
        const supportedFileTypes = {
          'image': 'image/',
          'video': 'video/',
          'pdf': 'application/pdf',
        };

        const mediaType = tw_media?.media_type;

        if (!mediaType) return null;

        for (const [key, value] of Object.entries(supportedFileTypes)) {
          if (mediaType.startsWith(value)) {
            return key;
          }
        }

        return 'unknown';
  },
  getExtensionType(file) {
    return file.tw_media ? this.getExtensionTypeFromTWMedia(file.tw_media) : this.getExtensionFromUrl(this.getMediaUrl(file))
  },

  shortenTextFullWord(text, maxLength) {
    const cutOffPoint = maxLength + 50;
    let indexOfSpaceAfter = text.substr(maxLength, cutOffPoint).indexOf(' ');
    const indexOfSpaceBefore = text.substr(0, maxLength).lastIndexOf(' ');

    if (text.length <= maxLength) {
      return text;
    }

    if (indexOfSpaceBefore === -1) {
      return text;
    }

    if (indexOfSpaceAfter !== -1) {
      indexOfSpaceAfter += maxLength;
    }

    // re-trim if we are in the middle of a word
    const trimmedString = text.substr(0, Math.max(indexOfSpaceBefore, indexOfSpaceAfter));

    return trimmedString;
  },

  removeDuplicatesFromArray(arr) {
    if (!Array.isArray(arr)) {
      return [];
    }

    return arr.filter((item, index, arr1) => arr1.indexOf(item) == index);
  },

  findMentionTagsInString(str) {
    if (typeof str !== 'string') {
      return [];
    }

    const tagsInText = str.match(this.regexFindMentionTagsInString);

    if (!tagsInText || tagsInText.length === 0) {
      return [];
    }

    const formattedTagsInText = tagsInText.map((tag) => tag.trim());

    return formattedTagsInText;
  },

  numberOfUniqueMentionTagsInString(str) {
    if (typeof str !== 'string') {
      return null;
    }

    const arrayOfTags = this.findMentionTagsInString(str);
    const uniqueTags = this.removeDuplicatesFromArray(arrayOfTags);
    const noOfUniqueTagsInText = uniqueTags.length;

    return noOfUniqueTagsInText;
  },

  returnVideoIndexInPhotos(message) {
    const { photos } = message;
    let photo;
    let index = 0;
    let vidRegexResult;
    let videoIndex = -1;

    if (!message.photos) {
      return videoIndex;
    }

    for (index in photos) {
      photo = photos[index];

      for (const vidTestIndex in window.globalObject.fileTypeExtensions.videoFileTypes) {
        const vidRegex = new RegExp(`\\${window.globalObject.fileTypeExtensions.videoFileTypes[vidTestIndex]}\\s*$`, 'gmi');
        vidRegexResult = vidRegex.exec(photo.link_url) || vidRegex.exec(photo.link_title);

        if (vidRegexResult !== null && vidRegexResult.length > 0 && vidRegexResult[1] !== '') {
          videoIndex = index;
          break;
        }
      }

      if (videoIndex) {
        break;
      }
    }

    return videoIndex;
  },

  matchStringWithvideoFileType(fileObject) {
    const files = fileObject;
    let file;
    let index = 0;
    let vidRegexResult;
    let videoIndex = -1;
    let vidRegex;
    // eslint-disable-next-line no-restricted-syntax
    for (index in files) {
      file = files[index];

      // eslint-disable-next-line no-restricted-syntax
      for (const vidTestIndex in window.globalObject.fileTypeExtensions.videoFileTypes) {
        vidRegex = new RegExp(`\\${window.globalObject.fileTypeExtensions.videoFileTypes[vidTestIndex]}\\s*$`, 'gmi');
        vidRegexResult = vidRegex.exec(file.name);

        if (vidRegexResult !== null && vidRegexResult.length > 0 && vidRegexResult[1] !== '') {
          videoIndex = parseInt(index, 10);
          break;
        }
      }

      if (videoIndex) {
        break;
      }
    }

    return videoIndex;
  },

  camelize(str) {
    return str.replace(/(\b\w)/gmi, (letter) => letter.toUpperCase());
  },

  convertPipeStringIntoArray(custFields) {
    const keyValPairs = custFields.split('|');

    custFields = [];
    for (let i = 0; i < keyValPairs.length; i++) {
      keyValPairs[i] = keyValPairs[i].split('=');
      if (!keyValPairs[i][0] || keyValPairs[i][0] == 'null') {
        continue;
      }
      custFields.push({
        parameter_description: '',
        parameter_name: keyValPairs[i][0],
        cfValue: keyValPairs[i][1] || '',
      });
    }
    return custFields;
  },

  getInstagramBusinessAccountId(select2Data) {
    let accountID;

    if (!select2Data) {
      return undefined;
    }

    const servList = _.pluck(select2Data, 'service');

    _.each(servList, (item) => {
      if (item.account_type.toLowerCase().indexOf('instagram') !== -1) {
        accountID = item.account_id;
      }
    });

    return accountID;
  },

  getMainContent() {
    if (window.Utils.$mainContent && window.Utils.$mainContent.length) {
      return window.Utils.$mainContent;
    }
    window.Utils.$mainContent = $('.main-content');

    return window.Utils.$mainContent;
  },
  setEqualHeights($container, $object, heightElement) {
    const $objects = $container.find($object);
    let tallest = 0;

    // Loop over all "row-fluid" rows
    $objects.each((index, element) => {
      const elementHeight = $(element).height();

      if (elementHeight > tallest) {
        tallest = elementHeight;
      }
    });

    if (heightElement) {
      $objects.find(heightElement).height(tallest);
      return;
    }
    $objects.height(tallest);
  },

  getToolBarsHeight() {
    return $('#top-bar').position().top + $('#top-bar').height() + 51;
  },

  cloneQueueSettings(modelToClone) {
    const newQueue = new QueueModel();

    newQueue.set('queue_name', `${window.lookup('Copy of')} ${modelToClone.get('queue_name')}`);
    newQueue.set('auto_detect', modelToClone.get('auto_detect'));
    newQueue.set('can_repeat', modelToClone.get('can_repeat'));
    newQueue.set('contributors', modelToClone.get('contributors'));
    newQueue.set('queue_times', modelToClone.get('queue_times'));
    newQueue.set('is_paused', modelToClone.get('is_paused'));
    newQueue.set('paused_until', modelToClone.get('paused_until'));

    return newQueue;
  },

  getKeyMetricScoreForMessage(msg) {
    return window.Utils.sendMessageCreatedGAInfo(msg, true);
  },

  sendUsedContentGAInfo(strAction) {
    // for scores see Gavins sheet here:
    // https://docs.google.com/spreadsheets/d/1EnitlJ_snf2HJ-UBHXZ-KyWBdmtMRd4m1XTBVpjJeZw/edit#gid=2028814869
    const mediaScoreTable = {
      Emoji: 1,
      'From RSS': 3,
      'From Content Library': 3,
      'From Suggested Content': 3,
    };

    if (typeof mediaScoreTable[strAction] === 'undefined') {
      throw new Error(`${strAction} is not a valid label for GA`);
    }

    try {
      window.Utils.sendGAUsageTracking({
        hitType: 'event',
        eventCategory: 'Publishing',
        eventAction: 'Used Content',
        eventLabel: strAction,
        eventValue: mediaScoreTable[strAction],
      });
    } catch (err) {
      reportErrorToFaro(err, 'utils sendUsedContentGAInfo');

      // something
    }
  },

  formatEngagementNumber(number, noTemplate) {
    const tmp = _.template('<span style="<%=color%>"><%=engagement%> <span class="icon icon-fire"></span></span>');
    const result = {
      engagement: null,
      color: '',
    };
    // <span style="color:#ff7512;"><%=engagement%> <span class="icon icon-fire"></span></span>
    // less then 100

    if (number <= 100) {
      result.engagement = number;
    }

    if (number > 100 && number < 1000) {
      // above 100 less then 1000
      result.engagement = `${Math.floor(number / 100) * 100}+`;
    }

    if (number >= 1000) {
      // above 1000
      result.engagement = `${Math.floor(number / 1000) * 1}K`;
      result.color = 'color:#ff7512;';
    }

    if (noTemplate) {
      return result.engagement;
    }
    return tmp(result);
  },

  sanitise(string) {
    const map = {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '/': '&#x2F;',
    };
    const reg = /[&<>/]/ig;
    return string.replace(reg, (match) => (map[match]));
  },

  sendAttachedMediaGAInfo(strAction) {
    // for scores see Gavins sheet here:
    // https://docs.google.com/spreadsheets/d/1EnitlJ_snf2HJ-UBHXZ-KyWBdmtMRd4m1XTBVpjJeZw/edit#gid=2028814869
    const mediaScoreTable = {
      'Image Uploaded': 1,
      'Video Uploaded': 1,
      'From URL': 3,
      'From Media Library': 2,
      'From DropBox': 1,
      'From Google Drive': 1,
      'From Canva': 2,
      'From YouTube': 1,
    };

    if (typeof mediaScoreTable[strAction] === 'undefined') {
      throw new Error(`${strAction} is not a valid label for GA`);
    }

    try {
      window.Utils.sendGAUsageTracking({
        hitType: 'event',
        eventCategory: 'Publishing',
        eventAction: 'Attached Media',
        eventLabel: strAction,
        eventValue: mediaScoreTable[strAction],
      });
    } catch (err) {
      reportErrorToFaro(err, 'utils sendAttachedMediaGAInfo');

      // something
    }
  },

  replaceInsecureProtocolURL(link) {
    if (link && link.indexOf('http:') !== -1) {
      link = link.replace('http:', 'https:');
    }
    return link;
  },

  updatePendoUserData() {
    const userDetails = loginContext.getDefaultLoginDetails();
    const isDevOrTest = process.env.SENDIBLE_ENV !== 'production';
    let pendoUserData;
    let pendoAccountData;

    try {
      pendoUserData = window.Utils.getPendoUserData(userDetails, isDevOrTest);
      pendoAccountData = window.Utils.getPendoAccountData(userDetails, isDevOrTest);

      pendo.updateOptions({
        visitor: pendoUserData,
        account: pendoAccountData,
      });
    } catch (err) {
      reportErrorToFaro(err, 'utils updatePendoUserData');

      // something
    }
  },

  getPendoUserData(userDetails, isDevOrTest) {
    try {
      const userId = window.Utils.getPendoIdField(userDetails, 'user_id', isDevOrTest);
      const isTrialist = this.accessDeepObject(userDetails, ['accountInfo', 'billing', 'plan', 'is_trial']);

      return {
        id: userId,
        full_name: this.accessDeepObject(userDetails, ['fullname']),
        email: this.accessDeepObject(userDetails, ['email']),
        plan_type: isTrialist ? 'Trialist' : 'Paying Customer',
        plan_tier: this.accessDeepObject(userDetails, ['accountInfo', 'billing', 'plan', 'name']),
        created_at: (new Date(this.accessDeepObject(userDetails, ['created_at']))).toISOString(),
        role: this.accessDeepObject(userDetails, ['profile']),
      };
    } catch (err) {
      reportErrorToFaro(err, 'utils getPendoUserData');

      return {};
    }
  },

  getPendoAccountData(userDetails, isDevOrTest) {
    try {
      const whiteLabelId = window.Utils.getPendoIdField(userDetails, 'white_label_id', isDevOrTest);

      return {
        id: whiteLabelId,
      };
    } catch (err) {
      reportErrorToFaro(err, 'utils getPendoAccountData');

      return {};
    }
  },

  getPendoIdField(userDetails, idKey, isDevOrTest) {
    const pendoIdField = this.accessDeepObject(userDetails, [idKey]);
    return isDevOrTest
      ? `test-${pendoIdField}`
      : pendoIdField.toString();
  },

  trackPendoEvent(eventName, eventDetails) {
    if (!pendo || typeof eventName !== 'string' || !window.appConfig.enablePendo) {
      return;
    }

    if (eventDetails && Object.keys(eventDetails).length > 0) {
      window.pendo.track(eventName, eventDetails);
    } else {
      window.pendo.track(eventName);
    }
  },

  handlePendoTrackingOfMessages(pendoEventsObject, sendDateClient, status, extraPendoData) {
    const lcStatus = status.toLowerCase();
    let strPendoEvent = '';

    if (lcStatus === 'pending' && !sendDateClient) {
      strPendoEvent = pendoEventsObject?.sent;
    } else if (lcStatus === 'pending' && sendDateClient) {
      strPendoEvent = pendoEventsObject?.scheduled;
    } else if (lcStatus === 'draft') {
      strPendoEvent = pendoEventsObject?.drafted;
    } else if (lcStatus === 'queued') {
      strPendoEvent = pendoEventsObject?.queued;
    } else if (lcStatus === 'content') {
      strPendoEvent = pendoEventsObject?.copyToLibrary;
    } else if (lcStatus === 'forapproval') {
      strPendoEvent = pendoEventsObject?.sentForApproval;
    }

    if (strPendoEvent) {
      Utils.trackPendoEvent(strPendoEvent, extraPendoData);
    }
  },

  getPendoMessageCreatedInfo(messageData) {
    const pendoData = {};
    let services = [];

    if (messageData?.message_id) {
      pendoData.postId = messageData.message_id;
    }

    if (messageData?.recipients && messageData.recipients.length) {
      services = _.pluck(messageData.recipients, 'account_type');
    }

    if (services.length) {
      pendoData.socialChannels = services.join(', ');
    }

    return pendoData;
  },

  callTrackPendoMessgeCreatedMultipleTimes(rawMessageResponse) {
    if (!$.isArray(rawMessageResponse) || rawMessageResponse.length === 0 || !$.isArray(rawMessageResponse[0]) || rawMessageResponse[0].length === 0) {
      Utils.trackPendoEvent('Message Created');
      return;
    }

    const messagesData = rawMessageResponse.map((item) => item[0] || {});

    messagesData.forEach((messageData) => {
      if (messageData?.message_id) {
        Utils.trackPendoEvent('Message Created', Utils.getPendoMessageCreatedInfo(messageData));
      }
    });
  },

  sendMessageCreatedGAInfo(messageToSave, scoreOnly) {
    const { status } = messageToSave;
    const recursInfo = messageToSave.recurs;
    const { recipients } = messageToSave;
    const GA_objects = [];

    try {
      // any message sent
      GA_objects.push({
        hitType: 'event',
        eventCategory: 'Publishing',
        eventAction: 'Message Created',
        eventLabel: 'Any',
        eventValue: 1,
      });

      // check status is pending only
      if (status == 'Pending' && (!recursInfo || recursInfo == 'Once-off')) {
        GA_objects.push({
          hitType: 'event',
          eventCategory: 'Publishing',
          eventAction: 'Message Created',
          eventLabel: 'Scheduled (once-off)',
          eventValue: 2,
        });
      }

      // check status is pending repeat
      if (status == 'Pending' && (typeof recursInfo !== 'undefined' && recursInfo !== 'Once-off')) {
        GA_objects.push({
          hitType: 'event',
          eventCategory: 'Publishing',
          eventAction: 'Message Created',
          eventLabel: 'Scheduled (repeat)',
          eventValue: 3,
        });
      }

      // check status is queued
      if (status == 'Queued') {
        GA_objects.push({
          hitType: 'event',
          eventCategory: 'Publishing',
          eventAction: 'Message Created',
          eventLabel: 'Queued',
          eventValue: 3,
        });
      }

      // check status is Draft
      if (status == 'Draft') {
        GA_objects.push({
          hitType: 'event',
          eventCategory: 'Publishing',
          eventAction: 'Message Created',
          eventLabel: 'Drafted',
          eventValue: 2,
        });
      }

      if ($('.CalendarView').length) {
        GA_objects.push({
          hitType: 'event',
          eventCategory: 'Publishing',
          eventAction: 'Message Created',
          eventLabel: 'From Calendar',
          eventValue: 2,
        });
      }

      // check if 3+ messages
      if (typeof recipients !== 'undefined' && recipients.length > 3) {
        GA_objects.push({
          hitType: 'event',
          eventCategory: 'Publishing',
          eventAction: 'Message Created',
          eventLabel: 'With 3+ profiles selected',
          eventValue: 2,
        });
      }

      // check if list selected
      if (typeof recipients !== 'undefined' && _.findWhere(recipients, { account_type: 'Group' })) {
        GA_objects.push({
          hitType: 'event',
          eventCategory: 'Publishing',
          eventAction: 'Message Created',
          eventLabel: 'With a list selected',
          eventValue: 2,
        });
      }

      if (scoreOnly) {
        return _.reduce(_.pluck(GA_objects, 'eventValue'), (memo, num) => memo + num, 0);
      }
      window.Utils.sendMultipleGAUsageTracking(GA_objects);
    } catch (err) {
      reportErrorToFaro(err, 'utils sendMessageCreatedGAInfo');

      // this is intentional
    }
  },

  sendMultipleGAUsageTracking(GA_objects) {
    let currentObject;
    if (GA_objects.length) {
      currentObject = GA_objects.pop();
      window.Utils.sendGAUsageTracking(currentObject);
      // recursive function: will call itself until
      // GA_objects is empty
      setTimeout(() => { window.Utils.sendMultipleGAUsageTracking(GA_objects); }, 800);
    }
  },

  sendGAUsageTracking(params) {
    if (ga && params) {
      ga('send', params);
    }
  },

  sanitiseServiceName(serviceName) {
    // compose-facebook-attachments
    let name;

    if (!serviceName) {
      return;
    }

    if (serviceName.indexOf('-') === -1) {
      return serviceName;
    }

    serviceName = serviceName.split('-');

    name = serviceName[1];

    if (serviceName[2] && serviceName[2] !== 'attachments'
              && serviceName[2] !== 'link' && serviceName[2] !== 'video') {
      name += `-${serviceName[2]}`;
    }

    return name;
  },

  storeAutoCompleteProfile(profile) {
    const profiles = new SocialProfileCollection();
    profiles.addProfile(profile, `${loginContext.getCurrentDetails().user_id}_autocomplete_twitter`);
  },

  getWordCount(val) {
    let wordCount = 0;
    let matchResult;

    if (val && val.length) {
      matchResult = val.match(/\S+/g);

      if (matchResult && matchResult.length) {
        wordCount = matchResult.length;
      }
    }

    return wordCount;
  },
  // creates a new guid, used for messages.
  guid() {
    const _guid = (function () {
      function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
          .toString(16)
          .substring(1);
      }
      return function () {
        return `${s4() + s4()}-${s4()}-${s4()}-${
          s4()}-${s4()}${s4()}${s4()}`;
      };
    }());
    return _guid();
  },

  loadLibrary(obj, lib) {
    if (typeof obj.lib === 'undefined') {
      obj.lib = {};
    }
    obj.lib = _.extend(obj.lib, lib);
  },

  setDefaultWindowBeforeUnload() {
    window.onbeforeunload = window.appConfig.onbeforeunload;
  },

  setDefaultWindowOnUnload() {
    window.onunload = window.appConfig.onunload;
  },

  //* *********************************************
  // Initializes tooltips, use after rendering a view.
  // Developer: GHammar
  //* *********************************************
  initTooltips() {
    $("button[rel='tooltip'], a[rel='tooltip'], a[data-toggle='tooltip'], i[rel='tooltip']").tooltip({ container: 'body' });
  },

  //* *********************************************
  // Displays a notification at the top of the screen. Used for alerts.
  // Developer: GHammar (set autoHide to automatically remove after a few seconds)
  //* *********************************************
  notify(text, type, withOverlay, autoHide, callback, onClicked, closedCallback, transparentOverlay, isWide) { // types: error, success, warning, info
    const that = this;

    // clear timeout if its still running
    window.clearTimeout(this.timeOut);

    // setup notify finished
    const notifyFinished = function () {
      if (callback) {
        callback();
      }
    };

    // if autohide then wait 5 seconds, then clear notifications.
    if (autoHide) {
      this.timeOut = setTimeout(() => {
        that.clearNotifications();
      }, 11000);
    }

    // run notification view
    notificationView.render(text, type, withOverlay, notifyFinished, onClicked, closedCallback, transparentOverlay, isWide);

    return notificationView;
  },

  notifyHide() {
    notificationView.close();
  },

  userAlert(text) {
    userAlertView.render(text);
  },

  isPopupBlocking(blocking, notBlocking) {
    setTimeout(() => {
      const newWin = window.open('http://www.bbc.co.uk', 'test', 'width=100, height=100');

      if (!newWin || newWin.closed || typeof newWin.closed === 'undefined') {
        blocking();
      } else {
        newWin.close();
        notBlocking();
      }
    }, 1500);
  },

  isAfterRestriction(sendDate) {
    const twoYearsFromNow = (moment().add(2, 'year'));

    return sendDate.isAfter(twoYearsFromNow);
  },

  notifyForCheckSave(beforeUnloadCB) {
    $('#left-sidebar, #top-control-bar, #top-bar').on('click', 'a', this.triggerAnchorClickedChrome);

    $('.js-main-col').on('click', '#right-sidebar a', this.triggerAnchorClickedRightSideBar);

    window.onbeforeunload = beforeUnloadCB;
  },

  triggerAnchorClickedChrome(evt) {
    if (evt.currentTarget.className.indexOf('dropdown-toggle') !== -1) {
      return;
    }

    Backbone.trigger('anchor-clicked:top-and-left-chrome', evt);
  },

  triggerAnchorClickedRightSideBar(evt) {
    if (evt.currentTarget.className.indexOf('dropdown-toggle') !== -1) {
      return;
    }
    Backbone.trigger('anchor-clicked:right-sidebar', evt);
  },

  disableNotifyForCheckSave() {
    $('#left-sidebar, #top-control-bar, #top-bar').off('click', 'a', this.triggerAnchorClickedChrome);

    $('.js-main-col').off('click', '#right-sidebar a', this.triggerAnchorClickedRightSideBar);

    // capture tab close
    window.onbeforeunload = window.appConfig.onbeforeunload;
  },

  // notifyIfPaused checks the current details is_paused property and
  // notifies the user if paused. This is called on startup (see utils.init)
  // and in preferences save method.
  notifyIfPaused() {
    const { is_paused } = loginContext.getCurrentDetails();

    // if paused let the user know
    if (is_paused) {
      window.Utils.notify(
        `${window.lookup('Your account is currently paused and your posts are not being sent.')
        } ${window.lookup('You can')} `
                  + `<a href="#manage/preferences/publishing">${
                    window.lookup('unpause your account within your preferences.')
                  }</a>`,
        'error',
      );
    } else {
      window.Utils.notifyHide();
    }
  },

  moveCheckBoxSelectedToTopLevel($domEl) {
    const $topLevel = $domEl.find('.topLevel');
    let selectedUsers = `${window.lookup('Selected users')}:`;
    const $holders = $topLevel.find('> span');

    if (!$topLevel.length) { return; }

    const $checkboxContainers = $domEl.find('.checkbox');

    const $checked = $checkboxContainers.find('input:checked');

    // first put unchecked items back in order if any
    if ($holders.length) {
      $holders.each(function () {
        const c_id = this.getAttribute('class').split('_')[1];
        const $cbox = $topLevel.find(`#id_${$.trim(c_id)}`);

        if ($cbox.is(':unchecked')) {
          $(this).replaceWith($cbox.parent().detach());
        }
      });
    }

    $checked.each(function () {
      const $el = $(this);
      selectedUsers += `<br/> ${$el.parent().text()}`;
      $topLevel.prepend($el.parent().replaceWith(`<span class="holder_${this.getAttribute('data-value')} ">`));
    });

    // $topLevel.prepend($checked.parent().detach());
    // $topLevel.prepend($checked.parent().replaceWith('<span class="holder_'+ +' ">'));

    $domEl.find('.total-selected').tooltip('destroy').text(
      window.lookup('99Pno selected').replace('99Pno', $checked.length),
    )
      .tooltip({
        html: true,
        title() {
          return selectedUsers;
        },
        placement: 'bottom',
        container: 'body',
      });

    $topLevel.scrollTop(0);

    $checkboxContainers.show();
  },

  createCheckBoxTree(treeInfo, $domEl, noChildSelection, addFilter, nestedLevel1) {
    let el;
    let markup = '';
    const itemTemplate = _.template('<label class="checkbox" data-title="<%=title.toLowerCase()%>" <%=inline%> ><input class="boxes" id="id_<%=value%>" type="checkbox" data-value="<%=value%>"><%=title%></label>');
    const len = treeInfo.length;
    const nestedLevel = nestedLevel1 || 0;
    let i = 0;

    if (!len) {
      return;
    }

    if (addFilter && !nestedLevel) {
      markup += '<input type="text" class="filter-checkbox input-medium" value="" /><span class="icon icon-remove"></span>';
      markup += `<p class="total-selected">${window.lookup('99Pno Selected').replace('99Pno', 0)}</p><div class="topLevel">`;
    }

    for (i; i < len; i++) {
      el = treeInfo[i];
      markup += itemTemplate({ title: el.title, value: el.value, inline: el.inline || '' });

      if (el.tree && el.tree.length) {
        markup += '<div class="nested">';
        markup += this.createCheckBoxTree(el.tree, null, false, null, 1);
        markup += '</div>';
      }
    }

    if (nestedLevel > 0) {
      return markup;
    }

    if (addFilter) {
      markup += '</div>';
    }

    // Add tree checkbox behaviour
    $domEl.append(markup);

    if (!noChildSelection) {
      $domEl.on('change', '> label .boxes', function () {
        const $parent = $(this);
        const check = $parent.prop('checked');
        const $childCheckboxs = $parent.parent().next().find('.boxes');

        $childCheckboxs.prop('checked', check);
      })
        .on('change', 'div .boxes', function () {
          const $checkbox = $(this);
          const check = $checkbox.prop('checked');
          if (check == false) {
            $checkbox.parent().parent().prev().find('.boxes')
              .prop('checked', false);
          }
        });
    }

    if (addFilter) {
      const $checkboxContainers = $domEl.find('.checkbox');

      $domEl.on('change', 'div .boxes', function () {
        const $checked = $checkboxContainers.find('input:checked');
        let selectedUsers = `${window.lookup('Selected users')}:`;
        const $holder = $domEl.find(`.holder_${this.getAttribute('data-value')}`);

        $checked.each(function () {
          const $el = $(this);
          selectedUsers += `<br/> ${$el.parent().text()}`;
        });

        if ($(this).is(':unchecked') && $holder.length) {
          $domEl.find(`.holder_${this.getAttribute('data-value')}`).replaceWith($(this).parent().detach());
        }

        $domEl.find('.total-selected').text(
          window.lookup('99Pno selected').replace('99Pno', $checked.length),
        );

        $domEl.find('.total-selected').tooltip('destroy').tooltip({
          html: true,
          title() {
            return selectedUsers;
          },
          placement: 'bottom',
          container: 'body',
        });
      });

      $domEl.find('.icon-remove, .total-selected').on('click', () => {
        window.Utils.moveCheckBoxSelectedToTopLevel($domEl);

        $domEl.find('.filter-checkbox').val('');
      });

      $domEl.find('.filter-checkbox')
        .on('keyup', function () {
          const $filter = $(this);
          const val = $filter.val().toLowerCase();

          if (val == '') {
            $domEl.find('.icon-remove').trigger('click');
            return;
          }
          $checkboxContainers.hide();

          const $found = $checkboxContainers.filter(`.checkbox[data-title^='${val}']`);

          $found.show();

          if ($found.next().hasClass('nested')) {
            $found.next().find('.checkbox').show();
          }
        });
    }
  },

  // detects modal show hide events in order to set correct zindex and
  // set the window.Utils property $currentmodal to the currently shown modal
  handleModalsShown() {
    let $visibleModals;

    window.Utils.$body.on('shown hidden', (e) => {
      if (e.target.className.indexOf('modal') === -1) { return; }

      if (e.target.id == 'queue-box') {
        $(e.target).find('#queueName').focus();
      }
      // Note: this event is triggered in order to trigger the
      // handleLargeModal event which normaly is trigger
      // on user scrolled
      window.Utils.triggerUserScrolled();

      $visibleModals = $('.modal:visible, .flex-modal:visible');
      if (!$visibleModals.length) {
        // if there is no visible modal
        window.Utils.$html.removeClass('stopScroll');
        window.Utils.$currentmodal = null;
        return;
      } if ($visibleModals.length == 1) {
        window.Utils.$currentmodal = $visibleModals;
        window.Utils.arrangeModals(null, window.Utils.$currentmodal);
      } else {
        window.Utils.$currentmodal = $visibleModals.last();
        $visibleModals = $visibleModals.not(':last');
        window.Utils.arrangeModals($visibleModals, window.Utils.$currentmodal);
      }

      window.Utils.$html.addClass('stopScroll');
    });
  },

  arrangeModals($visibleModals, $frontModal) {
    const $backdrop = $('.modal-backdrop:visible').first();
    let zIndex;

    zIndex = $backdrop.length ? parseInt($backdrop.css('z-index'), 10) : 9;

    if ($visibleModals) {
      $visibleModals.each(function () {
        $(this).css('z-index', zIndex);
      });
    }

    $frontModal.css('z-index', ++zIndex);
  },

  /**
       * handleLargeModal this will detect if the modal is bigger then the
       * viewport and allow the user to scroll the page to display the
       * whole modal dialog.
       * @param  jQuery $el     the element that will have 'modal' applied
       */
  $currentmodal: null,

  closeAllOpenModals() {
    $('.modal:visible, .flex-modal:visible').modal('hide');
  },

  handleLargeModal(e, WindowScrollTop, viewPortHeight) {
    let modalHeight = 0;
    let topMax = 0;
    let bottomMax = 0;
    let overHang = 0;
    const $mainContent = window.Utils.getMainContent();

    if (!viewPortHeight) {
      WindowScrollTop = window.Utils.$window.scrollTop();
      viewPortHeight = window.Utils.$window.height();
    }

    if (!window.Utils.$currentmodal) {
      $mainContent.css('paddingBottom', '');
      return;
    }

    modalHeight = window.Utils.$currentmodal.height();
    overHang = (modalHeight + (viewPortHeight * 0.05)) - viewPortHeight;

    if (overHang > 0) {
      window.Utils.$html.removeClass('stopScroll');
      window.Utils.$html.css('minHeight', viewPortHeight + overHang);

      if (typeof window.Utils.$currentmodal.refPos === 'undefined') {
        window.Utils.$currentmodal.refPos = WindowScrollTop;
        window.Utils.$currentmodal.css('top', '0px');
        return;
      }

      $mainContent.css('paddingBottom', '1000px');

      topMax = window.Utils.$currentmodal.refPos - overHang;
      bottomMax = window.Utils.$currentmodal.refPos;

      if (WindowScrollTop >= topMax && WindowScrollTop <= bottomMax) {
        window.Utils.$currentmodal.css('top', `${window.Utils.$currentmodal.refPos - WindowScrollTop}px`);
      } else if (WindowScrollTop <= topMax) {
        window.Utils.$currentmodal.css('top', '0px');
      } else if (WindowScrollTop >= bottomMax || WindowScrollTop == 0) {
        window.Utils.$currentmodal.css('top', `-${overHang}px`);
      }
    } else {
      $mainContent.css('paddingBottom', '');
      window.Utils.$html.css('minHeight', 'auto');
    }
  },

  forceModalFooter($el, options) {
    const that = this;
    const viewPortHeight = $(window).height();

    if (typeof options !== 'undefined') {
      $(window).resize(() => {
        that.forceModalFooter($el);
      });

      $el.on('hidden', () => {
        $(window).off('resize');
      });

      $el.modal(options);
    }

    $el.find('.modal-body').css('maxHeight', viewPortHeight - 200);
  },

  filterManager: {
    filter_keys: {},
    saveFilterForSession(filterName, filterValue) {
      const currentUserId = loginContext.getCurrentDetails().user_id;
      window.Utils.filterManager.filter_keys[filterName + currentUserId] = filterValue;
    },
    saveFilterForLongterm(filterName, filterValue) {
      const currentUserId = loginContext.getCurrentDetails().user_id;

      window.Utils.filterManager.filter_keys[filterName + currentUserId] = filterValue;

      localStorage.setItem(filterName + currentUserId, filterValue);
    },
    getFilter(filterName, checkCookie) {
      const currentUserId = loginContext.getCurrentDetails().user_id;
      let filterValue = window.Utils.filterManager.filter_keys[filterName + currentUserId];

      if (checkCookie && !filterValue) {
        filterValue = localStorage.getItem(filterName + currentUserId);
        window.Utils.filterManager.filter_keys[filterName + currentUserId] = filterValue;
      }

      return filterValue;
    },
    removeFilter(filterName, removeCookie) {
      const currentUserId = loginContext.getCurrentDetails().user_id;

      if (removeCookie) {
        localStorage.removeItem(filterName + currentUserId);
      }

      delete window.Utils.filterManager.filter_keys[filterName + currentUserId];
    },
  },

  clearNotifications() {
    notificationView.fadeOut();
  },

  removeNotificationClasses() {
    notificationView.removeClasses();
  },

  startProcess(text, withOverlay, transparentOverlay) {
    this.notify(text, 'info', withOverlay, null, null, null, null, transparentOverlay);
  },

  endProcess() {
    this.clearNotifications();
  },

  startLoading() {
    this.notify(`${window.lookup('Loading')}...`, 'info');
  },

  endLoading() {
    this.clearNotifications();
  },

  // creates a confirm dialog box...
  confirm(heading, question, cancelButtonTxt, okButtonTxt, callback, cancelCallback, useDontAskAgain) {
    const cancelBtnMarkup = cancelButtonTxt ? `<a id="cancelButton" class="btn btn-medium" data-dismiss="modal">${cancelButtonTxt}</a>` : '';
    const okBtnMarkup = okButtonTxt ? `<a id="okButton" class="btn btn-primary">${okButtonTxt}</a>` : '';
    const dontAskMarkup = useDontAskAgain ? `<label class="pull-left" style="margin-top: 10px;"><input class="not-again" type="checkbox" style="vertical-align: -12%;" /> ${window.lookup("Don't ask again")}</label>` : '';
    const confirmModal = $('<div class="modal hide fade">'
                  + '<div class="modal-header">'
                  + '<a class="close" data-dismiss="modal" >&times;</a>'
                  + `<h3>${heading}</h3>`
                  + '</div>'

                  + '<div class="modal-body">'
                  + `<p>${question}</p>`
                  + '</div>'

                  + `<div class="modal-footer">${
                    dontAskMarkup

                  }${cancelBtnMarkup

                  }${okBtnMarkup

                  }</div>`
                  + '</div>');

    confirmModal.find('#okButton').click((event) => {
      confirmModal.modal('hide');
      if (callback) callback($('.not-again').prop('checked'));
      event.stopPropagation();
    });

    confirmModal.find('#cancelButton, .close').click((event) => {
      // window.Utils.modal(confirmModal, 'hide');
      confirmModal.modal('hide');
      if (cancelCallback) cancelCallback($('.not-again').prop('checked'));
      event.stopPropagation();
    });

    confirmModal.on('hidden', () => {
      confirmModal.remove();
    });

    // window.Utils.modal(confirmModal, 'show')
    confirmModal.modal({ backdrop: 'static', keyboard: false });

    return confirmModal;
  },

  sanitiseInputText(s) {
    return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
  },

  // creates a confirm dialog box...
  singleInputModal(objOptions) {
    const {
      heading,
      inputValue1,
      cancelButtonTxt1,
      okButtonTxt1,
      placeholderText1,
      callback,
      cancelCallback,
      maxLength,
      descriptionText,
      textareaRows,
      saveClassName,
      afterInputHTML,
      allowEmpty,
      stopHide,
      useTextarea,
      validateMessage,
      forceValidation,
      isPassword,
      hideCancelBtn,
      shouldSanitiseInput = true
    } = objOptions;

    // setup variables
    const titleText = window.lookup('Please enter a value for this field');
    const inputValue = inputValue1 || '';
    const placeholderText = placeholderText1 || window.lookup('Please enter text');
    const textAreaOrInput = useTextarea === true ? 'textarea' : 'input';
    const cancelButtonTxt = cancelButtonTxt1 || window.lookup('Cancel');
    const cancelCallbackShim = cancelCallback || (() => {});
    const okButtonTxt = okButtonTxt1 || window.lookup('Ok');
    const errorMessage = validateMessage ? `<label class='error hide'>${validateMessage}.</label>` : '';
    const textareaRowsSet = textareaRows ? `rows="${textareaRows}"` : 'rows="4"';
    const extraSaveClassName = saveClassName || '';
    const afterInputHTMLEntered = afterInputHTML || '';
    const descriptionForInput = descriptionText ? `<p>${descriptionText}</p>` : '';
    const cancelBtn = hideCancelBtn ? '' : `<a class="btn btn-medium" data-dismiss="modal">${cancelButtonTxt}</a>`;
    const inputType = isPassword ? 'type="password"' : 'type="text"';
    const inputMarkup = useTextarea === true ? `<textarea style="resize: none;" class="input-block-level" ${textareaRowsSet} placeholder="${placeholderText}" >${inputValue}</textarea>`
      : `<input ${inputType} class="input-block-level" value="${inputValue}" required title="${titleText}" placeholder="${placeholderText}">`;

    const singleInputModal = $('<div class="modal hide fade">'
    + '<div class="modal-header">'
    + '<a class="close" data-dismiss="modal" >&times;</a>'
    + `<h3>${heading}</h3>`
    + '</div>'
    + '<div class="modal-body">'
    + `<form id="singleInputModalInput"><div class="control-group" data-original-title="" title="">${
      descriptionForInput
    }${inputMarkup
    }${errorMessage
    }${afterInputHTMLEntered
    }</div></form>`
    + '</div>'

    + `<div class="modal-footer">${
      cancelBtn
    }<button id="okButton" class="btn btn-success ${extraSaveClassName}">${
      okButtonTxt
    }</button>`
    + '</div>'
    + '</div>');
    const submitMethod = function () {
      const userValue = singleInputModal.find(`.modal-body ${textAreaOrInput}`).val();

      if (!allowEmpty && window.Utils.checkRequired($inputForm.find(textAreaOrInput)) == false) {
        // if not allowed to be blank then prevent closing
        if (forceValidation && userValue === '' || callback(userValue) === false) {
          singleInputModal.find('.modal-body p.error, .modal-body label.error').removeClass('hide');
          singleInputModal.find('.control-group').addClass('error');
        }

        return;
      }

      callback(
        shouldSanitiseInput ? Utils.sanitiseInputText(userValue) : userValue,
      );

      if (typeof stopHide === 'undefined' || stopHide !== true) {
        singleInputModal.modal('hide');
      }
    };

    singleInputModal.modal('show');
    window.Utils.isSingleInputShowing = true;
    singleInputModal.on('hidden', () => {
      const userValue = singleInputModal.find(`.modal-body ${textAreaOrInput}`).val();
      window.Utils.isSingleInputShowing = false;
      cancelCallbackShim(userValue);
      singleInputModal.remove();
    });

    // setup selector variables
    const $inputForm = singleInputModal.find('#singleInputModalInput');

    const $inputEl = singleInputModal.find('#singleInputModalInput .input-block-level');

    if (maxLength) {
      $inputEl.attr('maxlength', maxLength);
    }

    // bind events
    singleInputModal.find('#okButton').click(submitMethod);

    singleInputModal.find('input').on('keydown', () => {
      singleInputModal.find('input').removeClass('error');
      singleInputModal.find('.modal-body p.error').addClass('hide');
    });

    singleInputModal.on('hide', _.bind(() => {
      singleInputModal.find('input').off();
    }, this));

    if (!useTextarea) {
      const $inputFormInput = singleInputModal.find('#singleInputModalInput input');

      $inputFormInput.keypress((event) => {
        const key = event.keyCode || event.which;
        if (key === 13) {
          event.preventDefault();
          submitMethod();
        }
      });
    }
    return singleInputModal;
  },

  singleInputModalPromise(options) {
    return new Promise((resolve, reject) => {
      const optionsUpdate = {
        ...options,
        callback: (inputValue) => {
          if (options.callback) {
            options.callback();
          }
          resolve(inputValue);
        },
        cancelCallback: (inputValue) => {
          if (options.cancelCallback) {
            options.cancelCallback(inputValue);
          }
          resolve(false);
        },
      };
      this.singleInputModal(optionsUpdate);
    });
  },

  async promptPasswordConfirmation() {
    const confirmPassword = await Utils.singleInputModalPromise({
      heading: window.lookup('Enter your current password to confirm'),
      inputValue: '',
      cancelButtonText: null,
      placeholderText1: window.lookup('Enter password'),
      okButtonTxt1: window.lookup('Save'),
      isPassword: true,
      forceValidation: true,
      validateMessage: window.lookup('A password is required'),
      stopHide: false,
      hideCancelBtn: true,
      shouldSanitiseInput: false
    });

    if (confirmPassword === '') {
      Utils.notify(window.lookup('A password is required for this operation'), 'error', false, true);
      return '';
    }

    return confirmPassword;
  },

  checkRequired($input) {
    if ($input.val() === '') {
      $input.addClass('error');
      return false;
    }
    $input.removeClass('error');
    return true;
  },

  // ref: http://stackoverflow.com/a/1293163/2343
  // This will parse a delimited string into an array of
  // arrays. The default delimiter is the comma, but this
  // can be overriden in the second argument.
  csvToArray(strData, strDelimiter) {
    // Check to see if the delimiter is defined. If not,
    // then default to comma.
    strDelimiter = (strDelimiter || ',');

    // Create a regular expression to parse the CSV values.
    const objPattern = new RegExp(
      (
      // Delimiters.
        `(\\${strDelimiter}|\\r?\\n|\\r|^)`

                  // Quoted fields.
                  + '(?:"([^"]*(?:""[^"]*)*)"|'

                  // Standard fields.
                  + `([^"\\${strDelimiter}\\r\\n]*))`
      ),
      'gi',
    );

    // Create an array to hold our data. Give the array
    // a default empty first row.
    let arrData = [[]];

    // Create an array to hold our individual pattern
    // matching groups.
    let arrMatches = null;

    // Keep looping over the regular expression matches
    // until we can no longer find a match.
    // eslint-disable-next-line no-cond-assign
    while (arrMatches = objPattern.exec(strData)) {
      // Get the delimiter that was found.
      const strMatchedDelimiter = arrMatches[1];

      // Check to see if the given delimiter has a length
      // (is not the start of string) and if it matches
      // field delimiter. If id does not, then we know
      // that this delimiter is a row delimiter.
      if (
        strMatchedDelimiter.length
                  && strMatchedDelimiter !== strDelimiter
      ) {
        // Since we have reached a new row of data,
        // add an empty row to our data array.
        arrData.push([]);
      }

      let strMatchedValue;

      // Now that we have our delimiter out of the way,
      // let's check to see which kind of value we
      // captured (quoted or unquoted).
      if (arrMatches[2]) {
        // We found a quoted value. When we capture
        // this value, unescape any double quotes.
        strMatchedValue = arrMatches[2].replace(
          new RegExp('""', 'g'),
          '"',
        );
      } else {
        // We found a non-quoted value.
        strMatchedValue = arrMatches[3];
      }

      // Now that we have our value string, let's add
      // it to the data array.
      arrData[arrData.length - 1].push(strMatchedValue);
    }

    // Removes last row if not populated
    if (arrData[arrData.length - 1].length == 1) {
      arrData = _.first(arrData, arrData.length - 1);
    }
    // Return the parsed data.
    return (arrData);
  },

  // creates a prompt dialog box...
  prompt(question, callback) {
    const promptModal = $('<div class="modal hide fade">'
                  + '<div class="modal-header">'
                  + '<a class="close" data-dismiss="modal" >&times;</a>'
                  + `<h3>${question}</h3>`
                  + '</div>'

                  + '<div class="modal-body">'
                  + '<p><textarea class="input-block-level" rows="4" ></textarea></p>'
                  + '</div>'

                  + '<div class="modal-footer">'
                  + `<a class="btn" data-dismiss="modal">${window.lookup('Cancel')}</a>`
                  + '<a id="okButton" data-dismiss="modal" class="btn btn-primary">OK</a>'
                  + '</div>'
                  + '</div>');

    promptModal.find('#okButton').click(() => {
      callback(promptModal.find('textarea').val());
      // promptModal.modal('hide');
    });

    promptModal.modal('show');
  },

  //* *********************************************
  // Set and get values for this session only.
  // Developer: GHammar
  //* *********************************************
  set(key, value) {
    $.data(document.body, key, value);
  },

  get(key) {
    return $.data(document.body, key);
  },

  //* *********************************************
  // Check if user can perform certain events based
  // on current plan.
  // categoryName: e.g. lists
  // eventName: e.g. can_still_add
  // Possible eventNames: can_add_user, can_add_service
  //  can_add_app, can_add_list
  // Developer: GHammar
  //* *********************************************
  isAllowed(categoryName, eventName, callback, failCallback) {
    let category = categoryName;
    if (categoryName === 'services') {
      category = 'profiles';
    }

    const upgradeMessage = window.lookup('To add more 99Pcategory, please upgrade your account.').replace('99Pcategory', category);
    const upgradeMessageNonAdmim = window.lookup('To add more 99Pcategory, please contact your administrator to upgrade your account.').replace('99Pcategory', category);
    let additionalMessage = '';
    const limitInfo = loginContext.getBillingCreditsInfo() ? loginContext.getBillingCreditsInfo()[categoryName][eventName] : 1;

    if (loginContext.getBillingCreditsInfo() && loginContext.getBillingCreditsInfo()[categoryName] && loginContext.getBillingCreditsInfo()[categoryName].in_use && loginContext.getBillingCreditsInfo()[categoryName].total_available) {
      additionalMessage = `Wow, looks like you've already added ${loginContext.getBillingCreditsInfo()[categoryName].in_use} ${category}. This is the limit for the ${loginContext.getBillingCreditsInfo().billing.plan.name} plan.`;
    }

    if (limitInfo > 0) {
      callback();
      return;
    }
    if ($current_user.profile === 'Administrator') {
      this.confirm(
        window.lookup('Upgrade required'),
        `${additionalMessage} ${upgradeMessage}`,
        window.lookup('Cancel'),
        window.lookup('Select plan'),
        () => {
          // TODO: redirect to payment plan screen for upgrades.
          $('.modal').modal('hide');
          window.location = '#manage/subscription';
        },
      );
    } else {
      this.confirm(
        window.lookup('Upgrade required'),
        upgradeMessageNonAdmim,
        window.lookup('Close'),
        null,
        () => {
          // nothing happens, just close itself.
        },
      );
    }

    if (typeof failCallback !== 'undefined') {
      failCallback();
    }
  },

  // Recursive method to handle reading file, uses an index to read file as encode type
  readFile(file, encodeIndex, success, failure) {
    const reader = new FileReader();
    const encodeType = (encodeIndex === 0) ? '' : window.Utils.encodeTypes[(encodeIndex - 1)];

    // Closure to capture the file information.
    reader.onload = (_.bind(function () {
      return _.bind(function (e) {
        if (window.Utils.testForCharCode(e.target.result, 65533) === false) {
          success(e);
        } else {
          this.readFile(file, ++encodeIndex, success, failure);
        }
      }, this);
    }, this))(file);

    // if file does not load correctly with any encoding type
    if (typeof encodeType === 'undefined') {
      failure();
    }

    // Read the file as text
    reader.readAsText(file, encodeType);
  },

  determineIfImage(url, callback) {
    const image = new Image();

    image.onload = function () {
      callback(true);
      // do something...
    };
    image.onerror = function () {
      callback(false);
      // do something else...
    };

    image.src = url;
  },

  //* *********************************************
  // checkScroll detects when user scrolls to bottom
  // of screen and publishes an event to the active
  // view. The view should listen to this event in
  // order to load more messages
  // Developer: JSouris
  //* *********************************************
  onScrollRunning: false,
  checkScroll() {
    const $mainContent = window.Utils.getMainContent();

    if (window.globalObject.detectBottomReached(this) && (($mainContent.offset().top + $mainContent.height()) > window.Utils.$window.height())) {
      // notify
      // this ensures we only notify the view that is active
      // window.Utils.publish("reachedBottom-" + showing);
      if (window.Utils.loadMoreHandler) {
        window.Utils.loadMoreHandler();
      }
    }

    // run every 200ms
    if (!window.Utils.onScrollRunning) {
      window.Utils.triggerUserScrolled();
    }
  },

  triggerUserScrolled() {
    window.Utils.onScrollRunning = true;
    setTimeout(_.bind(() => {
      window.Utils.onScrollRunning = false;
      window.Utils.publish('onUserScrolled', [window.Utils.$window.scrollTop(), window.Utils.$window.height()]);
    }, this), 200);
  },

  loadMoreHandler: null,

  //* *********************************************
  // initLoadMoreEvent will set up the window scroll
  // event handler. Also sets up subscribes that
  // listen for when scrolled to bottom and triggers cb
  // Developer: JSouris
  //* *********************************************
  initLoadMoreEvent(viewName, callBack, onUserScrolled) {
    if (!viewName) {
      $(window).bind('scroll', this.checkScroll);
    } else {
      // $(document.body).data('active-view', viewName);

      // window.Utils.unsubscribe("reachedBottom-" + viewName, callBack);
      // window.Utils.subscribe("reachedBottom-" + viewName, callBack);
      window.Utils.loadMoreHandler = _.debounce(callBack, 500, true);
      if (onUserScrolled) {
        window.Utils.onUserScrolled = onUserScrolled;
        window.Utils.unsubscribe('onUserScrolled', onUserScrolled);
        window.Utils.subscribe('onUserScrolled', onUserScrolled);
      }
    }
  },
  resetLoadMoreEvents() {
    window.Utils.loadMoreHandler = null;
    if (window.Utils.onUserScrolled) {
      window.Utils.unsubscribe('onUserScrolled', window.Utils.onUserScrolled);
    }
  },

  setActiveView(viewName) {
    const { $body } = window.Utils;
    const previousActive = $body.data('active-view');

    // required for /measure/campaigns
    // FEV2 routes do not normally require a body class, but reports does for the custom sidebar
    // Body class cannot be set through FFEV2 due to 360 side effects removing it
    if (viewName.includes('measure')) {
      viewName = 'MeasureView';
    }

    $body.data('active-view', viewName);

    if (previousActive) {
      $body.removeClass(previousActive);
    }

    $body.addClass(viewName);
  },

  getAltTextSanitisedPhotoArray(photos) {
    return photos.map((photo) => {
      if (photo.alt_text) {
        return {
          ...photo,
          alt_text: photo.alt_text,
        };
      }
      return { ...photo };
    });
  },

  // this is used in both MessageCollection and MessageModel to correctly set
  // date related properties when a message is fetched from the server.
  // process emoji codes
  // and convert fb tags into human readable form
  // this used to be called setDateRelatedPropsAndEmojis
  prepareMessagesForApp(messages) {
    let recursUntil;
    let sendDate;

    _.each(messages, (message) => {
      recursUntil = new Date(message.recurs_until_client);
      sendDate = new Date(message.send_date_client);

      // fix null message rich text
      if (message && (typeof message.message_rich_text !== 'string' && typeof message.message_text === 'string')) {
        message.message_rich_text = message.message_text;
      }

      if (message.bounced_reason && !!message.bounced_reason.match(/<style/ig)) {
        if (message.bounced_reason.match(/<style[\s\S]*?<\/style>/gi)) {
          message.bounced_reason = message.bounced_reason.replace(/<style[\s\S]*?>([\s\S]+?)<\/style>/gi, '');
        } else {
          message.bounced_reason = window.lookup('Unknown error');
        }
      }

      if (message.status == 'Draft') {
        message.send_date_gmt_moment_with_offset = window.Utils.getNewGMTDateTimeWithOffset(message.dateCreated);
        message.offsetTimeDate = moment
          .utc(
            message.dateCreated
              .replace(/\//g, '-')
              .replace(' ', 'T')
              .replace(/ \+0000$/, ''),
          )
          .tz(loginContext.getCurrentDetails().timezone_name);
      } else if (typeof message.send_date_gmt !== 'undefined') {
        message.send_date_gmt_moment_with_offset = window.Utils.getNewGMTDateTimeWithOffset(message.send_date_gmt);
        message.offsetTimeDate = moment.utc(
          message.send_date_gmt
            .replace(/\//g, '-')
            .replace(' ', 'T'),
        )
          .tz(loginContext.getCurrentDetails().timezone_name);
      }

      // status === 'Draft' 'send_date_client' = moment(new Date()).format("YYYY/MM/DD HH:mm:ss");
      if (message.status == 'Draft') {
        // message.recurs = 'Once-off';
        message.queue_id = null;
      } else if ((recursUntil.getTime() <= sendDate.getTime()) && (message.queue_id == null || message.queue_id == '')) {
        message.recurs = 'Once-off';
        message.queue_id = null;
      } else if (message.queue_id !== null && message.queue_id !== '') {
        message.recurs = 'Once-off';
      }

      if (message.photos && message.photos.length) {
        message.photos = Utils.getAltTextSanitisedPhotoArray(message.photos);
      }

      window.Utils.processAnyFBTags(message);
    });
  },

  processCommentsFBTags(comments) {
    if (!comments) {
      return;
    }

    if (comments && comments.length) {
      _.each(comments, (item) => {
        try {
          // item.message = decodeURIComponent(item.message);
          // eslint-disable-next-line no-self-assign
          item.message = item.message;
          window.Utils.processAnyFBTags(item);
          window.Utils.processCommentsFBTags(item.comments);
        } catch (err) {
          reportErrorToFaro(err, 'utils processCommentsFBTags');

          item.message = window.Utils.replaceAll(item.message, '%', 'N');
        }
      });
    }
  },

  processAnyFBTags(message) {
    let decodedUn;
    let decodedCn;
    let fbKey;
    let fbTagInfoRich;
    let fbTagInfoPlain;
    let tagInfo;
    let richTextProperty;
    let plainTextProperty;
    let profilePrefix;

    if (typeof message === 'undefined') {
      return;
    }

    if (typeof message.message_rich_text !== 'undefined') {
      // richTextProperty = message.message_rich_text;
      richTextProperty = 'message_rich_text';
    } else if (typeof message.message_html !== 'undefined') {
      // richTextProperty = message.message_html;
      richTextProperty = 'message_html';
    }

    if (typeof message.message_text !== 'undefined') {
      // plainTextProperty = message.message_text;
      plainTextProperty = 'message_text';
    } else if (typeof message.message_unformatted !== 'undefined') {
      // plainTextProperty = message.message_unformatted;
      plainTextProperty = 'message_unformatted';
    } else if (typeof message.message !== 'undefined' && $.type(message.message) === 'string') {
      // plainTextProperty = message.message;
      plainTextProperty = 'message';
    } else if (typeof message.task_preview !== 'undefined' && $.type(message.task_preview) === 'string') {
      plainTextProperty = 'task_preview';
    }

    if (message?.send_to_descriptions && message?.send_to_descriptions?.toLowerCase().indexOf('instagram') !== -1) {
      profilePrefix = 'ig';
    }

    if (message?.send_to_descriptions && message?.send_to_descriptions?.toLowerCase().indexOf('threads') !== -1) {
      profilePrefix = 'th';
    }

    if (message && message.message && typeof message.message.message_rich_text !== 'undefined') {
      fbTagInfoRich = window.Utils.replaceMachineFBCodesWithHumanFBtags(message.message[richTextProperty], profilePrefix);
    }

    if (richTextProperty) {
      fbTagInfoRich = window.Utils.replaceMachineFBCodesWithHumanFBtags(message[richTextProperty], profilePrefix);
    }

    if (plainTextProperty) {
      fbTagInfoPlain = window.Utils.replaceMachineFBCodesWithHumanFBtags(message[plainTextProperty], profilePrefix);
    }

    if (fbTagInfoRich || fbTagInfoPlain) {
      tagInfo = fbTagInfoRich || fbTagInfoPlain;

      // loop thru entries and add to fbtagtable if includes html entities
      for (fbKey in tagInfo.convertFbTagCodes) {
        decodedUn = window.tinyMCE.html.Entities.decode(fbKey);
        // if selected mention will be converted to html entities by tinymce then
        // add 2nd entry to hash table
        if (decodedUn !== fbKey) {
          decodedCn = window.tinyMCE.html.Entities.decode(tagInfo.convertFbTagCodes[fbKey]);
          tagInfo.convertFbTagCodes[decodedUn] = decodedCn;
        }
      }

      if (richTextProperty) {
        message[richTextProperty] = tagInfo.message;
      }

      if (tagInfo.convertFbTagCodes) {
        message.facebookTagTable = tagInfo.convertFbTagCodes;
      } else if (tagInfo.labeledTagCodes) {
        message.labeledTagTable = tagInfo.labeledTagCodes;
      }
    }

    if (fbTagInfoPlain) {
      if (message.subject_unformatted && (message.subject_unformatted == message[plainTextProperty])) {
        message.subject_unformatted = tagInfo.message;
      }

      message[plainTextProperty] = fbTagInfoPlain.message;
    }
  },

  reOrderList(list, firstUnit) {
    const start = _.rest(list, list.indexOf(firstUnit));
    const end = _.first(list, list.indexOf(firstUnit));
    return start.concat(end);
  },

  // NOTE: This should only be used as a callback to the jquery
  // validation plugin on the property showErrors
  showErrors(errorMap, errorList) {
    this.defaultShowErrors();
    window.Utils.showErrorsNoInline(errorMap, errorList);
  },

  showErrorsNoInline(errorMap, errorList) {
    if (errorList && errorList.length) {
      $.each(errorList, function () {
        $(this.element).parents('.control-group').addClass('error');
      });
    }
  },

  preloadImage(imgUrl) {
    $('<img />').attr('src', imgUrl).appendTo('body').css('display', 'none');
  },

  preloadThemeImages() {
    if (permissionsManager.isWhiteLabel === false) {
      window.Utils.preloadImage('https://assets.sendible.com/holidays-theme/valentinesday/top-bar-theme.png');
      window.Utils.preloadImage('https://assets.sendible.com/holidays-theme/valentinesday/sidebar-theme.png');
    }
  },

  showThemeDay() {
    if (permissionsManager.isWhiteLabel === false) {
      $('.theme-day-asset').addClass('in');
      window.Utils.$html.addClass('enable-theme-day');
    }
  },

  /*
         Automates the creation and cleanup of bootstrap tooltips
         Ensures tooltips are removed when element is removed

         Input:
              $element (required): Element or Elements you want tooltips initialised on
              ignoreDepth (optional): If set to false or not specified children will be traversed to find all tooltips
      */
  createTooltips($elementArg, options1, ignoreChildrenTipsArgs, ignoreRel1) {
    const ignoreChildrenTips = (typeof ignoreChildrenTipsArgs !== 'undefined') ? ignoreChildrenTipsArgs : false;
    const $tooltip = (ignoreChildrenTips === false) ? $elementArg.find('[rel=tooltip]').add($elementArg) : $elementArg;
    const ignoreRel = (typeof ignoreRel1 !== 'undefined') ? ignoreRel1 : false;
    const options = (typeof options1 !== 'undefined') ? options1 : {};

    if (!options.trigger) {
      options.trigger = 'hover';
    }

    if (window.Utils.isMobile === false) {
      $tooltip.each(_.bind((index, element) => {
        const $element = $(element);
        const tooltipHolder = $element.hasClass('tooltip-holder');

        if (ignoreRel
                      || ($element.attr('rel') && $element.attr('rel') === 'tooltip')
                      || (($element.attr('title') && $element.attr('title') !== ''))) {
          $element.on('hide', (event) => {
            if (typeof $element === 'object') {
              event.stopPropagation();
            }
          });

          if (options.hasOwnProperty('delay') === false) {
            options.delay = {
              show: 5,
              hide: 5,
            };
          }

          if (options.hasOwnProperty('container') === false) {
            options.container = 'body';
          }

          if (tooltipHolder) {
            options.container = '.tooltip-holder';
          }

          $element.tooltip(options);
        }
      }, this));
    }
  },
  // processEmojiText
  // Example of what createEmojiMethod will create:
  // function emoj(s){
  // var o = [':smile:', ':laugh:', ':shy:'],
  //                     rplace = ['SS', 'LL', 'SHSH'];
  // var reg = new RegExp('(:smile:)|(:laugh:)|(:shy:)', 'g');
  //                     return s.replace(reg,
  //                         function (a) {
  //                             return rplace[o.indexOf(a)];
  //                         }
  //                     );
  // }
  // We're using the factory pattern to preprocess the emoji array and create a method
  // to efficiently replace emoji codes with proper emojis
  // from [ :smile: | 😄 ] to <span class="em em-smile">&nbsp;</span> or <img class="emoj-smile" />
  createEmojiMethod() {
    const arLookupCodes = [];
    const arLookupUtf8 = [];
    const arSynonymCodeItems = [];
    let strRXCodes = '';

    _.each(emojisArray, (item) => {
      let alteredItem;
      let arAliases;
      let i = 0;
      let len;

      if (item.aliases && item.aliases.length > 1) {
        len = item.aliases.length;
        arAliases = item.aliases;

        for (i; i < len; i++) {
          if (i === 0) {
            item.aliases = [arAliases[0]];
          } else {
            alteredItem = _.clone(item);
            alteredItem.aliases = [arAliases[i]];
            arSynonymCodeItems.push(alteredItem);
          }
        }
      }
    });

    emojisArray = emojisArray.concat(arSynonymCodeItems);

    _.each(emojisArray, (item) => {
      arLookupCodes.push(`:${item.aliases[0]}:`);
      arLookupUtf8.push(item.emoji);

      strRXCodes += `(${arLookupCodes[arLookupCodes.length - 1]})|`;
    });

    strRXCodes = strRXCodes.substr(0, strRXCodes.length - 1);

    // create regex objects
    const regexLookupCodes = new RegExp(strRXCodes, 'g');

    // create processemoji function and return.
    return function (message, returnFalseIfNoEmojiCode, ifNoCodeReturnMsg) {
      // by default we will assume that we should return false
      // if there is no emoji code in the message
      returnFalseIfNoEmojiCode = typeof returnFalseIfNoEmojiCode === 'undefined';

      if (!message) {
        if (returnFalseIfNoEmojiCode) {
          return false;
        }
        return '';
      }

      if (returnFalseIfNoEmojiCode && message.match(/:[\w+-]+:/) === null) {
        return false;
      }

      if (ifNoCodeReturnMsg && message.match(/:[\w+-]+:/) === null) {
        // dont process message just return
        return message;
      }

      if (message.indexOf(':+1:') !== -1) {
        message = message.replace(':+1:', ':thumbsup:');
      }

      return message.replace(
        regexLookupCodes,
        (a) => arLookupUtf8[arLookupCodes.indexOf(a)],
      );
    };
  },

  replaceMachineFBCodesWithHumanFBtags(message, profilePrefix = 'tw') {
    const tagCodes = {};
    const labeledTagCodes = {};

    if (!message || (message.indexOf('@[') == -1 && message.indexOf('@') == -1)) {
      return false;
    }

    if (message.indexOf('@') !== -1 && message.indexOf('@[') == -1) {
      message = message.replace(/@(\w*)/gi, (...args) => {
        const tagCode = args[1];

        labeledTagCodes[`${profilePrefix}_${tagCode}`] = `[${profilePrefix}_${args[1]}]`;
        return `@${tagCode}`;
      });
    }

    message = message.replace(/@\[(.*?)\]/gi, (...args) => {
      let tagCode = args[1];
      // tagCode example "@[fb_elizabeth_joh:2294984438]";

      if (tagCode.indexOf('liperson_') !== -1) {
        tagCode = tagCode.substr(0, tagCode.lastIndexOf(':'));

        labeledTagCodes[tagCode] = `[${args[1]}]`;
        return `@${tagCode.substr(9)}`;
      }
      if (tagCode.indexOf('fb_') !== -1
                      || tagCode.indexOf('li_') !== -1
                      || tagCode.indexOf('tw_') !== -1
                      || tagCode.indexOf('ig_') !== -1) {
        tagCode = tagCode.substr(0, tagCode.lastIndexOf(':'));

        labeledTagCodes[tagCode] = `[${args[1]}]`;
        return `@${tagCode.substr(3)}`;
      }
      if (tagCode.indexOf(':') !== -1) {
        tagCode = tagCode.substr(0, tagCode.lastIndexOf(':'));
        tagCodes[tagCode] = `[${args[1]}]`;
        return `@${tagCode}`;
      }
      tagCodes[tagCode] = `[${args[1]}]`;
      return `@${tagCode}`;
    });

    if (!_.isEmpty(tagCodes)) {
      return {
        message,
        convertFbTagCodes: tagCodes,
      };
    } if (!_.isEmpty(labeledTagCodes)) {
      return {
        message,
        labeledTagCodes,
      };
    }
  },

  replaceHumanFBCodesWithMachineFBtags(message, fbTable) {
    /*
          fbTable example
          {
              '@john' : '@[john:121212]'
          }
          */
    let key;
    let rXKey;
    let strSearch;
    let strHead;
    let orderedKeys;
    let i = 0;

    if (message.indexOf('@') !== -1) {
      orderedKeys = (_.keys(fbTable)).sort(
        (a, b) => b.length - a.length,
      );

      for (i; i < orderedKeys.length; i++) {
        key = orderedKeys[i];

        strSearch = key;

        strHead = key.substr(0, 3);

        if (strHead.indexOf('tw_') !== -1 || strHead.indexOf('th_') !== -1) {
          // no need to encode twitter or threads
          continue;
        }

        if (strHead.indexOf('li_') !== -1
                      || strHead.indexOf('fb_') !== -1) {
          strSearch = key.substr(3); // without tw_ fb_ li_
        } else if (key.indexOf('liperson_') !== -1) {
          strSearch = key.substr(9);
        }

        rXKey = new RegExp(`@${window.Utils.escapeRegExp(strSearch)}`, 'g');
        message = message.replace(rXKey, `@${fbTable[key]}`);

        if (key.indexOf('&') !== -1 && key.indexOf('&amp;') === -1) {
          rXKey = new RegExp(`@${window.Utils.escapeRegExp(strSearch.replaceAll('&', '&amp;'))}`, 'g');
          message = message.replace(rXKey, `@${fbTable[key].replaceAll('&', '&amp;')}`);
        }
      }
    }

    return message;
  },

  getAllCharacterCountsRemaining(plainText, igFirstCommentText) {
    const countersInfo = Object.entries(Utils.maxCharactersData)
      .map(([network, maxCount]) => {
        let text = plainText;
        if (network === 'instagramhashtags' && igFirstCommentText) {
          text = `${plainText}${igFirstCommentText}`;
        }
        return {
          network,
          text
        }
      });

    return Utils.charactersRemainingForNetworks(countersInfo);
  },

  charactersRemainingForNetworks(listMessageInfo) {
    const TWITTER = 'twitter';
    const IGHASHTAGS = 'instagramhashtags';

    if (!listMessageInfo || !listMessageInfo.length) {
      return [];
    }

    return listMessageInfo.map((info) => {
      const { network, text } = info;
      let textLength = (text ? text.length : 0);
      let matchedNetwork = Object.keys(Utils.maxCharactersData).find((key) =>
        network && network.toLowerCase() === key.toLowerCase()
      );

      const maxChars = matchedNetwork ? Utils.maxCharactersData[matchedNetwork] : 0;

      if (matchedNetwork === TWITTER) {
        textLength = twttr.getTweetLength(text);
      }

      if (matchedNetwork === IGHASHTAGS) {
        textLength = Utils.countHashTagsInString(text);
      }

      const remaining = maxChars - textLength;

      return { ...info, countRemaining: remaining };
    });
  },

  escapeRegExp(str) {
    return str.replace(/[-[\]/{}()*+?.\\^$|]/g, '\\$&');
  },

  hasGetUserMedia() {
    return !!(navigator.getUserMedia || navigator.webkitGetUserMedia
              || navigator.mozGetUserMedia || navigator.msGetUserMedia);
  },

  triggerLoadingState(evt, $btn1, callback) {
    const $btn = $btn1 || $(evt.target);
    $btn.button('loading');
    setTimeout(() => {
      $btn.button('reset');

      if (typeof callback !== 'undefined') {
        callback();
      }
    }, 1500);
  },

  replaceAll(txt, replace, with_this, notCaseSensitive) {
    let re;

    if (!txt) {
      return '';
    }

    if (notCaseSensitive) {
      re = new RegExp(replace, 'gi');
    } else {
      re = new RegExp(replace, 'g');
    }

    return txt.replace(re, with_this);
  },

  // replaces commas with &#44; for property string conversion needed forSendible.
  encodeCommas(text) {
    return window.Utils.replaceAll(text, ',', '&#44;');
  },

  // replaces &#44; with comma  for property string conversion needed forSendible.
  decodeCommas(text) {
    return window.Utils.replaceAll(text, '&#44;', ',');
  },

  encodeCharacter(character) {
    return `%${character.charCodeAt(0).toString(16)}`;
  },

  substituteBrokenChars(s) {
    const o1 = '‘’“”‚£€';
    const rplace = ['\'', '\'', '"', '"', ',', '&pound;', '&euro;'];

    return s.replace(
      /[‘’“”£‚€]/g,
      (a) => rplace[o1.indexOf(a)],
    );
  },

  toPropertyString(propertyHash) {
    const propertyArray = [];
    _.each(propertyHash, (val, key) => {
      propertyArray.push(`${key}=${window.Utils.encodeCommas(val)}`);
    });

    return propertyArray.join(',');
  },

  // Converts from a propertyOverride string to an object.
  fromPropertyString(propertyString) {
    const propertyHash = {};
    const properties = propertyString.split(',');
    _.each(properties, (el) => {
      const keyValues = el.split('=');
      propertyHash[keyValues[0]] = window.Utils.decodeCommas(keyValues[1]);
    });
    return propertyHash;
  },

  removeExtraSpacesInString(str) {
    if (!str) {
      return '';
    }
    return str.replace(/\s+/g, ' ');
  },

  applyDatesTooltipDateRangeFilter($dateFilter, start, end, removeArg) {
    if (start === null || end === null) {
      return;
    }

    const remove = (typeof removeArg !== 'undefined') ? removeArg : false;
    const $to = $dateFilter.find('.to-cal');
    const $from = $dateFilter.find('.from-cal');
    const $iconCalendar = $dateFilter.parents('.navElement').find('.dropdown-toggle');
    let tooltipMessage;
    const range = Math.abs(start.diff(end, 'days'));
    const startWeek = start.week();
    const startYear = start.year();
    const userWeek = $current_user.app_datetime_moment_readonly.week();
    const userYear = $current_user.app_datetime_moment_readonly.year();

    if (remove) {
      tooltipMessage = window.lookup('All time');

      $to.find('.selected').removeClass('selected');
      $from.find('.selected').removeClass('selected');

      $iconCalendar.removeClass('highlight');
      $iconCalendar.attr('title', tooltipMessage);

      window.Utils.createTooltips($iconCalendar);

      this.clearDatesFromDateRangeFilter($dateFilter);

      $to.datepicker('setEndDate');
      $from.datepicker('setEndDate', moment.utc().toDate());
    } else {
      tooltipMessage = `${start.format('D MMMM YYYY')} - ${end.format('D MMMM YYYY')}`;

      $to.datepicker('clearDates');
      $from.datepicker('clearDates');

      $to.datepicker('setEndDate');
      $from.datepicker('setStartDate');

      $to.datepicker('setDate', end.toDate());
      $from.datepicker('setDate', start.toDate());

      $to.find('.selected.active').click();

      $iconCalendar.addClass('highlight');
      $iconCalendar.attr('title', tooltipMessage);

      window.Utils.createTooltips($iconCalendar);
    }

    $iconCalendar.tooltip('hide')
      .attr('data-original-title', tooltipMessage)
      .tooltip('fixTitle');

    if (!remove) {
      if (range < 2 && start.isSame($current_user.app_datetime_moment_readonly, 'day')) {
        $dateFilter.find('.today').addClass('active');
      } else if (range > 2 && range < 8) {
        if (startWeek === userWeek) {
          $dateFilter.find('.this-week').addClass('active');
        } else if (startYear < userYear || startWeek < userWeek) {
          $dateFilter.find('.week-last').addClass('active');
        } else {
          $dateFilter.find('.next-week').addClass('active');
        }
      } else if (range > 8 && range < 32) {
        if (startYear < userYear || startWeek < userWeek) {
          $dateFilter.find('.month-last').addClass('active');
        } else if (startYear > userYear || startWeek > userWeek) {
          $dateFilter.find('.next-month').addClass('active');
        }
      }
    }
  },

  clearDatesFromDateRangeFilter($dateFilter) {
    const startDate = moment();
    let endDate = moment();
    const $to = $dateFilter.find('.from-cal');
    const $from = $dateFilter.find('.to-cal');

    startDate.subtract('month', 1)
      .startOf('month');

    endDate = startDate.clone();
    endDate.endOf('month');

    $to.datepicker('clearDates');
    $from.datepicker('clearDates');
  },

  testForCharCode(stringArg, charMatchArg) {
    let index = 0;
    let match = false;
    const string = stringArg || '';
    const charMatch = charMatchArg || 65533;

    for (index = 0; index < string.length; index++) {
      if (string.charCodeAt(index) === charMatch) {
        match = true;
        break;
      }
    }

    return match;
  },

  countHashTagsInString(str) {
    if (typeof str !== 'string' || !str || str === '') {
      return 0;
    }

    const hashtagPattern = /#([^#?=\s|$]+)/g;
    const found = str.match(hashtagPattern);

    return Array.isArray(found) ? found.length : 0;
  },

  showTransparentOverlay() {
    $('#page').addClass('notify').addClass('notify-transparent');
  },

  showTransparentPreventInteraction(opacityVal, hideTime, showTopNavigationBars) {
    const $overlay = $('.extraOverlay');

    $overlay.show().css('zIndex', 9999);

    if (showTopNavigationBars) {
      $('#top-bar, #top-control-bar').css('z-index', 99999);
    }

    if (opacityVal) {
      $overlay.css({ opacity: opacityVal, background: '#000' });
    }

    if (hideTime && !isNaN(hideTime)) {
      setTimeout(() => {
        window.Utils.hideTransparentPreventInteraction();
      }, parseInt(hideTime, 10));
    }
  },

  hideTransparentPreventInteraction() {
    const $overlay = $('.extraOverlay');

    $overlay.hide().css({ zIndex: 200, opacity: 0, background: 'transparent' });

    $('#top-bar').css('z-index', 5);
    $('#top-control-bar').css('z-index', 6);
  },

  hideTransparentOverlay() {
    $('#page').removeClass('notify').removeClass('notify-transparent');
  },

  showOverlay() {
    $('.permanentoverlayWrapper').css({ display: 'block' });
    $('.permanentoverlayWrapper .modal-backdrop').css({ display: 'block' });
  },

  removeOverlay() {
    $('.permanentoverlayWrapper').css({ display: 'none' });
  },

  getAmazonURLFromResponse(responseText) {
    const amazonUrlExtractionRegex = /<location>([\s\S]+?)<\/location>/i;
    return responseText.match(amazonUrlExtractionRegex);
  },

  autoExpandTextareaOnKeyUp($textArea) {
    const autoExpand = function (field) {
      // Reset field height
      field.style.height = 'inherit';

      // Get the computed styles for the element
      const computed = window.getComputedStyle(field);

      // Calculate the height
      const height = parseInt(computed.getPropertyValue('border-top-width'), 10)
                           + parseInt(computed.getPropertyValue('padding-top'), 10)
                           + field.scrollHeight
                           + parseInt(computed.getPropertyValue('padding-bottom'), 10)
                           + parseInt(computed.getPropertyValue('border-bottom-width'), 10);

      field.style.height = `${height}px`;
    };

    $textArea.on('keyup', (event) => {
      if (event.target.tagName.toLowerCase() !== 'textarea') return;
      autoExpand(event.target);
    });
  },

  calculateTextAreaHeight(field) {
    if (field) {
      // Reset field height
      field.style.height = 'inherit';
      // Get the computed styles for the element
      const computed = window.getComputedStyle(field);
      // Calculate the height
      const height = parseInt(computed.getPropertyValue('border-top-width'), 10)
                          + parseInt(computed.getPropertyValue('padding-top'), 10)
                          + field.scrollHeight
                          + parseInt(computed.getPropertyValue('padding-bottom'), 10)
                          + parseInt(computed.getPropertyValue('border-bottom-width'), 10);

      return height;
    }
  },

  openWindow(connectionUrl, success, error, openInLargeWindow, asTab) {
    let urlWindow;
    let windowTimer;
    const randomNumber = Math.floor((Math.random() * 100) + 1);
    const w = (openInLargeWindow) ? 868 : 650;
    const h = (openInLargeWindow) ? 650 : 450;
    const left = (screen.width / 2) - (w / 2);
    const top = (screen.height / 2) - (h / 2);
    const popupMessage = window.lookup('It appears you are either blocking popups or there was an error. Please check your popup settings and try again.');

    window.Utils.showOverlay();
    if (asTab) {
      urlWindow = window.open(connectionUrl, '_blank');
      urlWindow.focus();
    } else {
      urlWindow = window.open(connectionUrl, randomNumber, `toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=yes, resizable=yes, copyhistory=no, width=${w}, height=${h}, top=${top}, left=${left}`);
    }

    window.Utils.openWindows.push(urlWindow);

    const checkWindow = _.bind(() => {
      if (urlWindow.closed) {
        window.Utils.openWindows.splice(window.Utils.openWindows.indexOf(urlWindow), 1);
        clearInterval(windowTimer);
        window.Utils.removeOverlay();
        if (success) success();
      }
    }, this);

    if (!urlWindow || urlWindow.closed || typeof urlWindow.closed === 'undefined') {
      window.Utils.openWindows.splice(window.Utils.openWindows.indexOf(urlWindow), 1);
      window.Utils.removeOverlay();
      window.Utils.notify(popupMessage, 'error', false, true);
      error();
    } else {
      windowTimer = setInterval(checkWindow, 4000);
      setTimeout(() => {
        window.Utils.removeOverlay();
      }, 5000);
    }

    return urlWindow;
  },

  canAddService(id, account_id, isStreamService) {
    const billingCreditsInfo = loginContext.getBillingCreditsInfo();
    let can_still_add = null;

    if (billingCreditsInfo
              && typeof billingCreditsInfo.services !== 'undefined'
              && typeof billingCreditsInfo.services.can_still_add !== 'undefined') {
      can_still_add = billingCreditsInfo.services.can_still_add;
    }

    if (can_still_add === null) {
      window.Utils.notify(window.lookup("We're still fetching account information for you, please try again shortly."), 'info', false, true);
      return false;
    }

    return !(can_still_add <= 0 && id !== 15863 && (typeof account_id === 'undefined' || account_id === null) && !isStreamService);
  },

  addService(id, account_id, callbackSuccess, callbackError, isStreamService, openInLargeWindowArg) {
    let connectionUrl;
    let openInLargeWindow = openInLargeWindowArg || false;

    if (!window.Utils.canAddService(id, account_id, isStreamService)) {
      return;
    }

    // build connection URL
    connectionUrl = `${window.appConfig.api_url}/api/v2/connect?parent_domain=${encodeURIComponent(`${location.protocol}//${location.hostname}`)}&service_id=${id}&pricingEnabled=true`;
    if (typeof account_id !== 'undefined' && typeof account_id === 'number') {
      connectionUrl += `&account_id=${account_id}`;
    }
    connectionUrl += `&${loginContext.getLoginContextForAPI()}`;

    // if YouTube service ensure opened in larger window
    if (id === 9585) {
      openInLargeWindow = true;
    }

    window.Utils.openWindow(connectionUrl, callbackSuccess, callbackError, openInLargeWindow);
  },

  hasJustClicked() {
    const that = this;

    if (this.clickedButton) {
      return true;
    }

    this.clickedButton = true;

    setTimeout(() => {
      that.clickedButton = false;
    }, 800);

    return false;
  },

  Select2FilterMode($select2Element, messageText, optMinItemFilter) {
    const $selectedChoices = $select2Element.select2('container').find('.select2-choices');
    let timeout;
    const timeoutInterval = 1000;
    let minItemFilter = 2;

    function setTimeoutRunning() {
      const $container = $select2Element.select2('container');

      setTimeout(() => {
        if ($(`#${$container.attr('id')}:hover`).length < 1) {
          clearTimeout(timeout);
          timeout = setTimeout(() => {
            if ($(`#${$container.attr('id')}:hover`).length < 1 && $container.hasClass('select2-dropdown-open') === false) {
              $container.find('.select2-search-field .select2-input').blur();
            }
          }, timeoutInterval);
        }
      }, 100);
    }
    if (!window.Utils.$html.hasClass('ie8')) {
      if (messageText === undefined) messageText = 'Filtering by <span class="select2-filter-message-counter"></span> items';

      if (typeof optMinItemFilter !== 'undefined') {
        minItemFilter = optMinItemFilter;
      }

      // checking for mouseout
      $select2Element.select2('container').mouseout(() => {
        setTimeoutRunning();
      });

      /* On DOM insert
                   *
                   * if DOM element inserted
                   *
                   */

      $selectedChoices.bind('DOMNodeInserted', (event) => {
        const $selected = $selectedChoices.select2('container').find('.select2-search-choice');

        // if the event concerns a search choice and we have more than x selected continue
        if ($(event.target).hasClass('select2-search-choice') && $selected.length >= minItemFilter) {
          // if no message element then add one, else update its text
          if ($selectedChoices.find('.select2-filter-message').length < 1) {
            $selectedChoices.append(`<li class="select2-filter-message hidden">${messageText}</li>`).find('.select2-filter-message-counter').text($selected.length);
          } else {
            $selectedChoices.find('.select2-filter-message').html(messageText).find('.select2-filter-message-counter').text($selected.length);
          }

          if ($(event.target).hasClass('hidden') === false) {
            $selectedChoices.find('li.select2-filter-message').addClass('hidden');
          }
        }
      });

      // on element removed
      $select2Element.on('select2-removed', () => {
        const $selected = $selectedChoices.select2('container').find('.select2-search-choice');
        const $parentModal = $selectedChoices.parents('.modal');

        // if less than x selected remove the message else update the message
        if ($selected.length < minItemFilter) {
          $selectedChoices.find('.select2-filter-message').remove();
        } else {
          // update the message text
          $selectedChoices.find('.select2-filter-message').html(messageText).find('.select2-filter-message-counter').text($selected.length);
        }
      });

      // on focus hide items and show the message
      $select2Element.on('select2-focus', () => {
        const $selected = $selectedChoices.select2('container').find('.select2-search-choice');

        $selectedChoices.find('.select2-filter-message').addClass('hidden');
        $selected.removeClass('hidden');
      });

      // on blur show items and hide the message
      $select2Element.on('select2-blur', () => {
        let $selected;

        clearTimeout(timeout);

        setTimeout(() => {
          $selected = $selectedChoices.select2('container').find('.select2-search-choice');

          if (!$select2Element.select2('container').hasClass('select2-container-active')) {
            if ($selected.length >= minItemFilter) {
              $selectedChoices.find('.select2-filter-message').removeClass('hidden');
              $selected.addClass('hidden');
            }
          }
        }, 100);
      });

      $select2Element.on('select2-selecting', () => {
        setTimeoutRunning();
      });
    }
  },

  calculateTimezoneOffet(timezone, date) {
    let timeOffset;

    const timeDifference = Math.abs(timezone - loginContext.getCurrentDetails().timezone);

    if (timezone < loginContext.getCurrentDetails().timezone) {
      timeOffset = -Math.abs(timeDifference);
    } else {
      timeOffset = timeDifference;
    }

    return moment(date).add(timeOffset, 'minutes');
  },

  isMaxQueueLimitAndClient(queuesArray) {
    if (!queuesArray || !queuesArray.length) {
      return false;
    }

    const { profile } = loginContext.getDefaultLoginDetails();
    const limitReached = js_featurMngr.isFeatureRestricted(js_featurMngr.codes.COMPOSE_QUEUES, queuesArray.length);
    const CLIENT = 'Client';
    return limitReached && profile === CLIENT;
  },

  checkGoog(hideMessage) {
    let showNotify = true;

    if (typeof google === 'undefined') {
      if (typeof hideMessage !== 'undefined') {
        if (hideMessage === true) {
          showNotify = false;
        }
      }

      if (showNotify) {
        window.Utils.notify(window.lookup('Unfortunately this feature is temporarily unavailable due to a problem with Google profiles. Please try again later.'), 'error', false, true);
      }

      return false;
    }
    return true;
  },

  processMultiPartMedia(files, callback) {
    const uploadmediaModel = new UploadMediaModel();

    _.each(files, (file) => {
      file.multipart = true;
    });

    uploadmediaModel.set({
      files,
    });

    // save the media model
    uploadmediaModel.save({}, {
      fileType: 'localFile',
      success: _.bind((model, resp) => {
        callback(resp);
      }, this),
      error: _.bind(() => {
      }, this),
    });
  },

  localStorage(item) {
    return {
      get() {
        return JSON.parse(localStorage.getItem(item));
      },
      set(data) {
        localStorage.setItem(item, JSON.stringify(data));
      },
      remove() {
        localStorage.removeItem(item);
      },
    };
  },

  processMedia(files, callback, options1, error) {
    const uploadmediaModel = new UploadMediaModel();
    const options = (typeof options1 !== 'undefined') ? options1 : {};
    const fileType = (options.hasOwnProperty('fileType') ? options.fileType : 'localFile');

    uploadmediaModel.set({
      files,
    });

    // save the media model
    uploadmediaModel.save({}, {
      fileType,
      success: _.bind((model, resp) => {
        callback(resp);
      }, this),
      error: _.bind(() => {
        if (error) {
          error();
        }
      }, this),
    });
  },

  convertImgToBase64(url, callback) {
    let canvas = document.createElement('CANVAS');
    const ctx = canvas.getContext('2d');
    const img = new Image();

    img.crossOrigin = 'Anonymous';
    img.onload = _.bind(() => {
      let filename;
      let base64img;

      canvas.height = img.height;
      canvas.width = img.width;
      ctx.drawImage(img, 0, 0);

      filename = decodeURIComponent(url.substring(url.lastIndexOf('/') + 1));

      // find filename extension
      const fileExtension = /[^.]+$/.exec(filename);

      if (!!fileExtension && fileExtension == 'png') {
        filename = `${filename.replace(/\.[^.]+$/, '')}.png`;
        base64img = canvas.toDataURL('image/png', 1);
      } else {
        filename = `${filename.replace(/\.[^.]+$/, '')}.jpg`;
        base64img = canvas.toDataURL('image/jpeg', 1);
      }

      // Clean up
      canvas = null;

      // this.modalParent.closeAll();
      callback(base64img, filename);
    }, this);

    img.src = url;
  },

  convertTimeTo24(time) {
    // strips am/pm
    // time = time.replace(/[^(\d|:)]/g, "");

    if (loginContext.getCurrentDetails().militaryTime == true) {
      time = moment(time, 'HH:mm').format('HH:mm');
    } else {
      time = moment(time, 'hh:mma').format('HH:mm');
    }

    return time;
  },

  getTabIdFromSenderType(sender_type, list_type) {
    let tabID = '';
    let sender_type_lc;
    let list_type_lc;

    if (typeof sender_type === 'string') {
      sender_type_lc = sender_type.toLowerCase();
    }
    if (typeof list_type === 'string') {
      list_type_lc = list_type.toLowerCase();
    }

    if (((list_type_lc && list_type_lc.indexOf('social') !== -1)
              || (sender_type_lc && sender_type_lc.indexOf('social') !== -1))) {
      tabID = 'compose-group';
    } else if (!sender_type_lc) {
      return tabID;
    } else if (sender_type_lc.indexOf('facebook') !== -1) {
      tabID = 'compose-facebook';
    } else if (sender_type_lc.indexOf('googlemybusiness') !== -1) {
      tabID = 'compose-googlemybusinesslocation';
    } else if (sender_type_lc.indexOf('wordpress') !== -1) {
      tabID = 'compose-wordpress';
    } else if (sender_type_lc.indexOf('youtube') !== -1) {
      tabID = 'compose-youtube';
    } else if (sender_type_lc.indexOf('linkedin') !== -1) {
      tabID = 'compose-linkedin';
    } else if (sender_type_lc.indexOf('pinterest') !== -1) {
      tabID = 'compose-pinterest';
    } else if (sender_type_lc.indexOf('instagram') !== -1) {
      tabID = 'compose-instagram';
    } else if (sender_type_lc.indexOf('twitter') !== -1) {
      tabID = 'compose-twitter';
    } else if (sender_type_lc.indexOf('tiktok') !== -1) {
      tabID = 'compose-tiktok';
    } else if (sender_type_lc.indexOf('threads') !== -1) {
      tabID = 'compose-threads';
    }

    return tabID;
  },

  getCustomValuesString(attrServiceId, serviceID, keyName, valName, noPipeEnding) {
    let strCustomValues = '';

    if (serviceID && attrServiceId) {
      if (parseInt(serviceID, 10) === parseInt(attrServiceId, 10)) {
        strCustomValues += `${keyName}=${valName || ''}`;
        strCustomValues += '|';
      }
    } else {
      strCustomValues += `${keyName}=${valName || ''}`;
      strCustomValues += '|';
    }

    if (strCustomValues.indexOf('|') !== -1 && noPipeEnding) {
      strCustomValues = strCustomValues.substr(0, strCustomValues.length - 1);
    }

    return strCustomValues;
  },

  setWeekStartOnDateLibrary(dow = 0) {
    if (!moment?.locale) {
      return;
    }

    moment.locale('en', {
      week: {
        dow
      },
    });
  },

  /* getNewDateTime
       * Arguments: date and time (format: "2015-01-20", "15:00:00")
       * Returns: moment instance (linked to app_datetime) with current users timezone applied
       * only takes time as a 24h object. use utils.convertTimeTo24
       */
  getNewDateTime(date, time, gmt) {
    let dateTimeClone = $current_user.app_datetime_moment_readonly.clone();
    const dateDelimiter = ['/', '-'];
    const timeDelimiter = [':'];
    let year;
    let month;
    let day;
    let hours;
    let minutes;
    const isGMt = (typeof gmt === 'undefined') ? false : gmt;

    if (isGMt === true) {
      dateTimeClone = $current_user.app_datetime_moment_GMT_readonly.clone();
    }

    if (typeof date === 'undefined' || typeof time === 'undefined') {
      return false;
    }

    if (!moment(date).isValid() || !moment(time, 'H:mm').isValid()) {
      return false;
    }

    _.find(dateDelimiter, (delimiter) => {
      if (date.match(delimiter).length > 0) {
        date = date.split(delimiter);
        year = date[0];
        month = date[1];
        day = date[2];
        return delimiter;
      }
    });

    _.find(timeDelimiter, (delimiter) => {
      if (time.match(delimiter).length > 0) {
        time = time.split(delimiter);
        hours = time[0];
        minutes = time[1];
        return delimiter;
      }
    });

    dateTimeClone.set('year', year);
    dateTimeClone.set('month', (parseInt(month, 10) - 1));
    dateTimeClone.set('date', day);
    dateTimeClone.set('hour', hours);
    dateTimeClone.set('minute', minutes);

    return dateTimeClone;
  },

  /* getNewGMTDateTimeWithOffset
       * Arguments: GMT time (format: "2015-01-20 15:00:00")
       * Returns: moment instance (independant from app_datetime) with current users timezone applied
       */
  getNewGMTDateTimeWithOffset(gmtTime) {
    return moment.utc(
      gmtTime
        .replace(/\//g, '-')
        .replace(' ', 'T')
        .replace(/(\s\+\d{4})/, ''),
    )
      .tz(loginContext.getCurrentDetails().timezone_name);
  },

  /* getNewNativeDateTimeWithOffset
       * Arguments: native GMT time (format: "Tue Jan 20 2015 14:15:08 GMT+0000 (GMT Standard Time)")
       * Returns: moment instance (linked to app_datetime) with current users timezone applied
       */
  getNewNativeDateTimeWithOffset(gmtTime) {
    const dateTimeClone = $current_user.app_datetime_moment_readonly.clone();
    const momentString = gmtTime.toString().slice(4, 24);

    dateTimeClone.set('year', momentString.slice(7, 11));
    dateTimeClone.set('month', momentString.slice(0, 3));
    dateTimeClone.set('date', momentString.slice(4, 6));
    dateTimeClone.set('hour', momentString.slice(12, 14));
    dateTimeClone.set('minute', momentString.slice(15, 17));

    return dateTimeClone;
  },

  async checkElementExistence(elementId, ticker, checkInterval) {
    const timeout = function (interval) { return new Promise((resolve) => { setTimeout(resolve, interval); }); };

    await timeout(checkInterval);
    const element = document.getElementById(elementId);

    if (ticker < 1) {
      return false;
    } if (element) {
      return true;
    }
    --ticker;
    return window.Utils.checkElementExistence(elementId, ticker, checkInterval);
  },

  nextVisiblejqueryElement($el) {
    if (!($el instanceof jQuery)) {
      return false;
    }

    $el = $el.next();
    if ($el.is(':visible')) {
      return $el;
    }
    return window.Utils.nextVisiblejqueryElement($el);
  },

  buildISOTimezoneOffset(numericOffset) {
    let offset = (parseInt(numericOffset, 10) / 60);
    let minutes = ':00';

    if ((Math.abs(offset) % 1) !== 0) {
      minutes = `:${Math.abs((offset % 1)) * 60}`;

      if (offset < 0) {
        offset = Math.ceil(offset);
      } else {
        offset = Math.floor(offset);
      }
    }

    if (offset === 0) {
      offset = '+00';
    }

    if (offset < 0 && offset > -10) {
      offset = `-0${(`${offset}`).slice(1, offset.length)}`;
    }

    if (offset > 0 && offset < 10) {
      offset = `+0${offset}`;
    }

    if (offset > 9) {
      offset = `+${offset}`;
    }

    const offsetISO = (offset + minutes);

    return offsetISO;
  },

  checkAppTime() {
    if ($current_user.app_datetime_timezone_readonly) {
      return true;
    }
    return false;
  },

  bitlyHelpUrl() {
    return permissionsManager.isWhiteLabel
      ? 'https://support.bitly.com/hc/en-us/articles/230647907-How-do-I-find-my-OAuth-access-token-'
      : 'https://support.sendible.com/hc/en-us/articles/360021876751';
  },

  removeBrokenImages($imageArray) {
    $imageArray.each((index, image) => {
      image.onerror = function () {
        this.remove();
      };
    });
  },

  setupCampaignsSelector($control, preSelectedCampaigns = []) {
    if (!$control?.length) {
      return;
    }

    $control.makeFilter({
      type: 'campaigns',
      useFilterMode: true,
      filterMessage: '<span class="select2-filter-message-counter"></span> Campaigns selected',
      allowClear: true,
      multiple: true,
    }).on('makeFilter-built', (event, campaigns) => {
      if (campaigns?.length) {
        $control.parent().addClass('in');
        if (preSelectedCampaigns?.length) {
          setTimeout(() => {
            $control.select2('val', _.pluck(preSelectedCampaigns, 'id'), true)
              .select2('close');
          }, 0);
        }
      } else {
        $control.select2('destroy').parent().remove();
      }
    });
  },
  replaceEncodedHyphens(input) {
    // Regular expression to match common encoded hyphens
    const hyphenEntities = /&#45;|&ndash;|&mdash;|–|—/g;
    // Replace them with a standard hyphen
    return input.replace(hyphenEntities, '-');
  },
};

window.Utils.helpers = {
  prevDayString: '',
  runOnce: false,

  getNextQueueTime(queue_times) {
    if (this.runOnce) {
      return;
    }
    this.runOnce = true;

    let closest = window.Utils.Queue.getClosestQueueTime(queue_times);

    closest = closest.format('dddd[,] DD MMMM');

    return '<div class="row-fluid ">'
              + `<strong data-cy="date-display">${closest}</strong>`
              + '</div>';
  },

  getFormatedDate(sDate) {
    sDate = moment(sDate).format('dddd[,] DD MMMM');

    return '<div class="row-fluid">'
              + `<strong data-cy="date-display">${sDate}</strong>`
              + '</div>';
  },

  getMessagesDateString(sDate) {
    let dayString = moment(sDate, 'ddd MMM DD HH:mm:ss Z YYYY').format('dddd, D MMMM');
    const todayString = moment(new Date()).format('dddd, D MMMM');
    const tomorrowString = moment(new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 1)).format('dddd, D MMMM');
    const yesterdayString = moment(new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() - 1)).format('dddd, D MMMM');

    if (dayString == todayString) {
      dayString = window.lookup('Today');// + ", " + dayString;
    } else if (dayString == tomorrowString) {
      dayString = window.lookup('Tomorrow');// + ", " + dayString;
    } else if (dayString == yesterdayString) {
      dayString = window.lookup('Yesterday');// + ", " + dayString;
    }

    this.prevDayString = dayString;
    return `<div class="row-fluid dayString" data-day-string="${dayString}">`
              + `<strong data-cy="date-display">${dayString}</strong>`
              + '</div>';
  },

  getMessagesDateKeywords(sDate) {
    let dayString = moment(sDate, 'YYYY/MM/DD hh:mm:ss Z').format('dddd, D MMMM');
    const todayString = moment(new Date()).format('dddd, D MMMM');
    const tomorrowString = moment(new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 1)).format('dddd, D MMMM');
    const yesterdayString = moment(new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() - 1)).format('dddd, D MMMM');

    if (dayString == todayString) {
      dayString = window.lookup('Today');// + ", " + dayString;
    } else if (dayString == tomorrowString) {
      dayString = window.lookup('Tomorrow');// + ", " + dayString;
    } else if (dayString == yesterdayString) {
      dayString = window.lookup('Yesterday');// + ", " + dayString;
    }

    this.prevDayString = dayString;
    return `<div class="row-fluid dayString" data-day-string="${dayString}">`
              + `<strong data-cy="date-display">${dayString}</strong>`
              + '</div>';
  },

  getMessagesDateStringMoment(sDate, $checkDom) {
    let dayString = sDate.format('dddd, D MMMM');
    const todayString = $current_user.app_datetime_moment_readonly.format('dddd, D MMMM');
    const tomorrowString = $current_user.app_datetime_moment_readonly.clone().add(1, 'days').format('dddd, D MMMM');
    const yesterdayString = $current_user.app_datetime_moment_readonly.clone().subtract(1, 'days').format('dddd, D MMMM');

    if (dayString == todayString) {
      dayString = window.lookup('Today');// + ", " + dayString;
    } else if (dayString == tomorrowString) {
      dayString = window.lookup('Tomorrow');// + ", " + dayString;
    } else if (dayString == yesterdayString) {
      dayString = window.lookup('Yesterday');// + ", " + dayString;
    } else if (parseInt($current_user.app_datetime_moment_readonly.format('YYYY'), 10) < parseInt(sDate.format('YYYY'), 10)) {
      dayString = sDate.format('dddd, D MMMM YYYY');
    }

    this.prevDayString = dayString;

    // if checkDom passed then check if date el already present in checkdom
    if ($checkDom && $checkDom.find(`div[data-day-string="${dayString}"]`).length) {
      return false;
    }

    return `<div class="row-fluid dayString" data-day-string="${dayString}">`
              + `<strong data-cy="date-display">${dayString}</strong>`
              + '</div>';
  },

  // for #search view
  getMessagesDateStringSearch(sDate) {
    let dayString = moment(sDate, 'ddd MMM DD HH:mm:ss Z YYYY').format('dddd, D MMMM');

    const todayString = moment(new Date()).format('dddd, D MMMM');
    const tomorrowString = moment(new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 1)).format('dddd, D MMMM');
    const yesterdayString = moment(new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() - 1)).format('dddd, D MMMM');

    if (dayString == todayString) {
      dayString = window.lookup('Today');// + ", " + dayString;
    } else if (dayString == tomorrowString) {
      dayString = window.lookup('Tomorrow');// + ", " + dayString;
    } else if (dayString == yesterdayString) {
      dayString = window.lookup('Yesterday');// + ", " + dayString;
    }

    this.prevDayString = dayString;
    return `<div class="row-fluid dayString" data-day-string="${dayString}">`
              + `<strong data-cy="date-display">${dayString}</strong>`
              + '</div>';
  },

  // template helper
  getDayString(sDate, simple) {
    let dayString = this.getFromNow(sDate);
    if (dayString == 'a day ago') {
      dayString = 'Yesterday';
    }
    if (simple) {
      return window.lookup(dayString);
    }

    if (this.prevDayString != dayString && $('#page').find(`[data-day-string='${dayString}']`).length == 0) {
      this.prevDayString = dayString;
      return `<div class="row-fluid dayString" data-day-string="${dayString}">`
                  + `<strong data-cy="date-display">${window.lookup(dayString)}</strong>`
                  + '</div>';
    }
  },
  // template helper
  getRepliedAgo(sDate) {
    return moment(sDate, 'YYYY-MM-DD HH:mm').fromNow();
  },
  // template helper
  getFormatedTime(sDate) {
    return moment(new Date(sDate)).format(loginContext.getCurrentDetails().timeFormat);
  },
  // template helper
  getRecursIcon(recurs) {
    if (recurs !== '' && recurs !== 'Once-off') {
      return '<i class="icon-refresh icon-flip-horizontal"></i>';
    }
  },
  // template helper
  getFromNow(sDate) {
    return moment(new Date(sDate)).fromNow();
  },
  daysToCancellation() {
    const currentTimestamp = new Date().setHours(0, 0, 0, 0);
    const nextPaymentTimeStamp = (new Date(loginContext.getCurrentDetails().next_payment).setHours(0, 0, 0, 0));
    const isTrial = /trial/i.test(loginContext.getCurrentDetails().user_status);
    const timestampDay = 1000 * 60 * 60 * 24;
    let daysLeft = 0;

    if (!isNaN(nextPaymentTimeStamp)) {
      daysLeft = ((nextPaymentTimeStamp - currentTimestamp) / timestampDay).toFixed();

      if (!isTrial) {
        daysLeft -= 1;
      }
    }

    if (daysLeft < 1) {
      daysLeft = 0;
    }

    return daysLeft;
  },
};

window.Utils.Message = {
  getMessageRecursData(message, extraRecursData) {
    let endDate;

    if (typeof extraRecursData !== 'undefined') {
      message = {
        recurs: extraRecursData.recurs,
        send_date_client: extraRecursData.starts,
        recurs_until_client: extraRecursData.ends,
      };
    }

    if (!message || message.recurs === ''
              || message.recurs === 'Once-off' || !message.recurs) {
      return false;
    }

    const startDate = new Date(message.send_date_client);
    endDate = new Date(message.recurs_until_client);

    // if start date is later than end date
    // then set end date = start date

    if (startDate.getTime() > endDate.getTime()) endDate = new Date(message.send_date_client);

    const recurs = {
      start: startDate,
      end: endDate,
      onDays: message.recurs.substr(3),
      unit: message.recurs.substr(2, 1),
      increment: parseInt(message.recurs.substr(0, 2), 10),
    };
    return recurs;
  },
  getSummaryForMessage(message, capitalise) {
    // repeater, timeUnitBasic, starts, ends, timeEnds, daysToSend
    const recursData = this.getMessageRecursData(message);

    this.repeatsState = this.updateRepeatState(
      recursData.increment,
      recursData.unit,
      recursData.start,
      recursData.end,
      recursData.onDays,
    );

    return this.getSummary(this.repeatsState, capitalise);
  },
  updateRepeatState(repeater, timeUnitBasic, starts, ends, daysToSend) {
    let strOnlyOn = '';
    let timeUnit;
    const repeatsState = {};

    repeatsState.no_onlyOn = false;
    repeatsState.repeater = repeater;

    repeatsState.timeUnitBasic = timeUnitBasic;

    timeUnit = window.Utils.timeUnits[repeatsState.timeUnitBasic];

    if (repeatsState.timeUnitBasic !== 'D' && repeatsState.timeUnitBasic !== 'H') {
      repeatsState.no_onlyOn = true;
    }
    timeUnit += (repeatsState.repeater > 1 ? 's' : '');
    repeatsState.timeUnit = timeUnit;

    repeatsState.starts = starts;

    repeatsState.ends = ends;

    if (repeatsState.no_onlyOn) {
      strOnlyOn = '1111111';
    } else if (daysToSend instanceof $) {
      daysToSend.each(function () {
        strOnlyOn += this.checked ? '1' : '0';
      });
    } else {
      strOnlyOn = daysToSend;
    }

    repeatsState.onlyOn = strOnlyOn;

    return repeatsState;
  },
  getSummary(repeatsState, capitalise) {
    const summaryTemplate = `<%=every %> <%=repeater %> <%=timeUnit %> ${
      window.lookup('until')} <%=prettyEnds %> <%if(textOnlyOn !== ''){%> <%=textOnlyOn %> <%}%>`;
    let i = 0;
    let daysAdded = 0;
    let strDays = '';
    let checkedDays;
    let andDay;
    let lang;

    if (dictionary.common.daysOfWeek[$current_user.language]) {
      lang = $current_user.language;
    } else {
      lang = 'en';
    }

    const arDays = dictionary.common.daysOfWeek[lang].split(' ');

    const len = arDays.length;

    if (repeatsState.no_onlyOn) {
      strDays = '';
    } else if (repeatsState.onlyOn === '1111100') {
      strDays = `${window.lookup('Only on')} ${window.lookup('weekdays')}`;
    } else if (repeatsState.onlyOn === '0000011') {
      strDays = `${window.lookup('Only on')} ${window.lookup('weekends')}`;
    } else if (repeatsState.onlyOn === '1111111') {
      strDays = window.lookup('Every day of the week');
    } else {
      for (i; i < len; i++) {
        if (repeatsState.onlyOn.charAt(i) == 1) {
          strDays += `${arDays[i]}, `;
          daysAdded++;
        }
      }

      strDays = strDays.substr(0, strDays.length - 2);

      if (daysAdded > 1) {
        checkedDays = strDays.split(' ');
        andDay = checkedDays[checkedDays.length - 2];
        checkedDays[checkedDays.length - 2] = `${andDay.substr(0, andDay.length - 1)} ${window.lookup('and')} `;
        strDays = checkedDays.join(' ');
      }

      strDays = `${window.lookup('only on')} ${strDays}`;
    }

    repeatsState.textOnlyOn = strDays;

    if (capitalise) {
      repeatsState.every = window.lookup('Every');
    } else {
      repeatsState.every = window.lookup('every');
    }

    repeatsState.prettyEnds = moment(repeatsState.ends).format('D MMMM YYYY');
    return _.template(summaryTemplate, repeatsState);
  },
};

window.Utils.Queue = {
  getClosestQueueTime(queueTimes, startDay) {
    const tempDate = startDay || $current_user.app_datetime_moment_readonly;
    const today = tempDate.clone();

    if (queueTimes.length === 0) {
      return false;
    }

    queueTimes = _.map(queueTimes, (time) => {
      // monday is 0 in queue times
      const correctDay = time.weekday === 6 ? 0 : time.weekday + 1;
      let newDate;

      if (startDay) {
        newDate = (startDay.clone()).day(correctDay).hours(time.hour).minutes(time.minute);
      } else {
        newDate = ($current_user.app_datetime_moment_readonly.clone()).day(correctDay).hours(time.hour).minutes(time.minute);
      }

      // push to next week if date has passed
      if (newDate.isBefore(today)) {
        newDate.add('d', 7);
      }
      return newDate;
    }).sort((a, b) => a.valueOf() - b.valueOf());

    const firstTime = queueTimes[0];

    return firstTime;
  },
  getQueueDates(queueTimes, startDay) {
    let qDates = _.map(queueTimes, (queue) => {
      if (startDay) {
        return window.Utils.Queue.getClosestQueueTime([queue], startDay);
      }
      return window.Utils.Queue.getClosestQueueTime([queue]);
    });
    // sort qDates
    qDates = qDates.sort((a, b) => a - b);
    return qDates;
  },
};

/**
   * Sendible jQuery plugins go here
   */

/**
   * makeFilter is a jquery plugin
   * converts any static select tag to a select2 filter populated from a specified
   * data source
   *
   * Usage:
   * markup:
   *
   * <select class="select-input"
   *         multiple="multiple"
   *         data-placeholder="select ">
   * <select>
   *
   * $('.select-input')
   *             .makeFilter({
   *                         //this will fetch the specified items to
   *                         //populate the 'select' tag from the server
   *                         type : [ 'users' | 'services' | libraries ],
   *
   *                         //this will add an option to the select tag
   *                         //with the text all
   *                         includeAll : [ true | false],
   *
   *                         //Any additional select2 options you have go
   *                         //here
   *                         select2 : {select2 options}
   *                         })
   */

(function ($) {
  const defaults = {
    type: 'other',
    optionTemplate: _.template(optionTemplate, null, {
      variable: 's',
    }),
  };
  // users | services |
  function MakeFilter(element, options) {
    const widget = this;

    widget.config = $.extend(true, {}, defaults, options);
    widget.element = element;
    widget.htmlOptions = '';
    // fetch datasource if url supplied and cache val and id
    // if datasource is json object then cache val and id
    this.init();
  }

  MakeFilter.prototype = {
    init() {
      const that = this;
      const options = { reset: true };
      let fetchPromise = null;

      switch (this.config.type) {
        case 'users':
          this.dataCollection = new UserCollection();
          options.concise = true;
          options.profile = 'Active';
          options.page = 1;
          break;
        case 'campaigns':
          this.dataCollection = new CampaignCollection();
          if (!this.config?.showAllCampaigns) {
            options.activeCampaignsOnly = true;
          }
          break;
        case 'mediaLibraries':
          this.dataCollection = new MediaLibraryCollection();
          break;
        case 'usersAll':
          this.dataCollection = new UserCollection();
          options.concise = true;
          options.profile = 'All';
          options.page = 1;
          break;
        case 'services':
          this.dataCollection = new ServiceCollection();
          options.per_page = 3500;
          break;
        case 'servicesSocial':
          this.dataCollection = new ServiceCollection();
          options.type = 'social';
          options.per_page = 3500;
          break;
        case 'servicesSocialAndAllGroups':
          this.dataCollection = new ServiceCollection();
          options.type = 'social_and_all_groups_nomixed';
          // social_and_all_groups
          break;
        case 'streamServicesSocial':
          this.dataCollection = new InboxServiceCollection();
          options.type = 'social';
          break;
        case 'libraries':
          this.dataCollection = new LibraryCollection();
          break;
        case 'lists':
          this.dataCollection = new ListsCollection();
          options.list_type = this.config.list_type || 'mixed';
          break;
        case 'reportAccounts':
          // do nothing. this is used with customCollection
          this.dataCollection = true;
          break;
        case 'reports':
          // do nothing. this is used with customCollection
          // this.dataCollection = new ReportCollection();
          this.dataCollection = true;
          break;
        case 'usersFilter':
        case 'permissions':
          this.dataCollection = new PermissionProfileCollection();
          break;
        case 'listType':
          this.build([{ title: 'SMS', id: 'SMS' }, { title: 'Email', id: 'Email' }]);
          break;
        case 'serviceTypes':
          this.dataCollection = new ServiceTypesCollection();
          break;
        default:
          this.build([]);
          return;
      }

      if (this.config.ignoreCache) {
        options.ignoreCache = true;
      }

      if (this.dataCollection !== undefined) {
        if (this.config.customCollection) {
          this.dataCollection = this.config.customCollection;
        } else {
          fetchPromise = this.dataCollection.fetch(options);
        }
        $.when(fetchPromise)
          .then(
            () => {
              if (that.config.type === 'users' || that.config.type === 'usersAll') {
                that.dataCollection.setUserHierarchy();
                if (that.config.exclude_user_by_id) {
                  that.dataCollection.remove(
                    parseInt(that.config.exclude_user_by_id, 10),
                  );
                }
              }

              that.build(
                that.mapItems(that.config.type, that.dataCollection.toJSON()),
              );

              if (that.config.onFetch) that.config.onFetch(that.dataCollection);
            },
            () => {
              $(that.element).trigger('makeFilter-error');
            },
          );
      }
    },
    build(items) {
      const cnf = this.config;
      const that = this;
      let select2Options = {};
      const $element = $(this.element);

      _.extend(select2Options, cnf.select2 || null);

      // template
      if (cnf.includeAll) {
        that.htmlOptions += `<option value="all" >${window.lookup('All')}</option>`;
      }

      $.each(items, function () {
        that.htmlOptions += cnf.optionTemplate({
          item: this,
        });
      });

      if (cnf.includeOther) {
        that.htmlOptions += `<option value="${cnf.includeOther.val}" data-recipient-id="${cnf.includeOther.val}" >${_.escape(cnf.includeOther.title)}</option>`;
      }

      if (that.htmlOptions !== '') {
        $element.append(that.htmlOptions);
      }

      // custom options for different type
      if (cnf.type === 'users' || cnf.type === 'usersAll') {
        _.extend(select2Options, {
          containerCssClass: 'usersContainer',
          formatResult: this.formatUsers,
          formatSelection: this.config.showColor ? this.formatUsers : this.formatUsersResult,
          escapeMarkup(m) {
            return m;
          },
        });
      } else if (cnf.type === 'reportAccounts' || cnf.type === 'services' || cnf.type === 'serviceTypes' || cnf.type === 'servicesSocial' || cnf.type === 'streamServicesSocial' || cnf.type === 'servicesSocialAndAllGroups') {
        _.extend(select2Options, {
          formatResult: this.formatService,
          formatSelection: this.formatService,
          escapeMarkup(m) {
            return m;
          },
        });
      } else if (cnf.type === 'permissions') {
        select2Options.minimumResultsForSearch = -1;
      } else if (cnf.type === 'lists') {
        select2Options = {
          minimumResultsForSearch: -1,
        };
      } else if (cnf.type === 'other') {
        select2Options.containerCssClass = 'usersContainer';
      }

      if (typeof cnf.dropdownCssClass !== 'undefined') {
        select2Options.dropdownCssClass = cnf.dropdownCssClass;
      }

      // run select2 code
      $element.select2(select2Options);

      if (!this.config.silent) {
        setTimeout(() => {
          $element.trigger('makeFilter-built', [items]);
        }, 0);
      }

      if (cnf.useFilterMode) {
        setTimeout(() => {
          Utils.Select2FilterMode($element, cnf.filterMessage, cnf.filterMinLimit);
        }, 0);
      }

      // if filter is service type then prevent the selection of
      // more then one twitter account
      if (cnf.type.indexOf('service' !== -1) && cnf.limitToOneTwitter) {
        $element.on('change', this.checkIfTwitterTwice);
      }

      // for user filter only. remove HR tag in li and place before the li
      $element.on('select2-open', (event) => {
        if ($(event.currentTarget).attr('id') !== 'usersFilter_SelectBox') {
          return;
        }

        $('#select2-drop').find('li').each((index, element) => {
          if ($(element).find('hr').length > 0) {
            $(element).find('hr').remove();
            $(element).before('<hr>');
          }
        });
      });
    },

    checkIfTwitterTwice(evt, listData) {
      const $target = $(evt.target);
      const data = $target.select2('data');
      let twitterCount = 0;
      let id_added;
      let $listItem;

      const arDatasets = _.map(_.pluck(data, 'element'), (element) => element[0].dataset);

      const len = arDatasets.length;

      if (evt.removed && evt.removed.id) {
        $target.find(`option[data-id="${evt.removed.id}"]`).removeAttr('data-has-twitter');
      }

      for (let i = 0; i < len; i++) {
        if ((arDatasets[i].itemType.toLowerCase()).indexOf('twitter') !== -1) {
          twitterCount++;
        } else if ($target.find(`option[data-id="${arDatasets[i].id}"]`).attr('data-has-twitter')) {
          twitterCount++;
        }
      }

      if (twitterCount > 0) {
        // if list added account_type == "Group" then remove from selection like this, fetch info about list see "select2-selecting
        // using account.json
        /*
                  //remove the last twitter account added
                  currentSelection = _.pluck(data, 'id');

                  id_added = evt.added.id;

                  currentSelection = _.reject( currentSelection, function(numId){
                      return numId == id_added;
                  });

                  $target.select2('val', currentSelection);
                  */

        if (evt.added && evt.added.id) {
          id_added = evt.added.id;

          $target.find('option[data-item-type="Twitter"]')
            .not(`option[data-id="${id_added}"]`)
            .prop('disabled', true);
        } else if (listData && listData.list_id) {
          id_added = listData.list_id;
          $listItem = $target.find(`option[data-id="${id_added}"]`);

          if ($listItem.attr('data-has-twitter')) {
            $listItem.prop('disabled', true);
          } else {
            $target.select2('val', (_.pluck(arDatasets, 'id')).concat(listData.list_id));
          }
        }

        // else if (evt.list_id){
        //     $target.find('option[data-item-type="Twitter"]').add('option[data-has-twitter]').prop('disabled', true);

        //     _.each($target.select2('val'), function(id_selected){
        //         $target.find('option[data-id="' + id_selected + '"]').prop('disabled', false);
        //     });
        // }
      } else {
        if (listData && listData.list_id) {
          $target.select2('val', (_.pluck(arDatasets, 'id')).concat(listData.list_id));
        }

        $target.find('option[data-item-type="Twitter"]').add('option[data-has-twitter]').prop('disabled', false);
      }
    },
    getManagerIds() {
      const currentUser = loginContext.getCurrentDetails();

      const userList = currentUser?.lineage && currentUser.lineage.includes('-') ? currentUser.lineage.split('-') : null;

      if (userList) {
        return userList.slice(0, -1).map((str) => Number(str));
      }

      return userList;
    },
    mapItems(type, items) {
      let mappedItems;
      let alreadySelected = false;
      const that = this;
      const currentUser = loginContext.getCurrentDetails();
      const loggedInUserId = loginContext.getDefaultLoginDetails().user_id;
      const managerIds = this.getManagerIds();

      if (this.config.type === 'users' || this.config.type === 'usersAll') {
        mappedItems = _.filter(_.map(items, (user) => {
          let selected = false;

          if (that.config.excludeCurrentUser && currentUser.id == user.id) {
            return;
          }

          if (that.config.excludeManager && managerIds && managerIds.includes(user.id) && loggedInUserId !== user.id) {
            return;
          }

          if (that.config.selectCurrentUser && currentUser.id == user.id) {
            selected = true;
          }

          if (that.config.selectNonCurrentUser && currentUser.id !== user.id && !alreadySelected) {
            selected = true;
            alreadySelected = true;
          }

          return {
            id: user.id,
            title: user.fullname,
            selected,
            color: user.color,
            userHierarchy: user.userHierarchy,
            avatar: user.avatar,
            username: user.login,
            api_key: user.api_key,
          };
        }), (item) => typeof item !== 'undefined');

        if (this.config.select2nd && mappedItems[1]) {
          mappedItems[1].selected = true;
        }
      } else if (type === 'services' || type === 'servicesSocial' || type === 'streamServicesSocial' || type === 'servicesSocialAndAllGroups') {
        mappedItems = _.map(items, (service) => ({
          id: service.id,

          recipient_id: service.recipient_id,
          extra_recipients: service.extra_recipients || '',
          description: service.account_name,
          item_type: service.account_type,

          title: service.account_name,
          account_type: service.account_type,
          selected: false,
          iconUrl: service.icon_url,
        }));
      } else if (type === 'reportAccounts') {
        mappedItems = _.map(items, (service) => ({
          id: service.id,
          description: service.description,
          item_type: service.report_type,
          title: service.account_name,
          account_type: service.report_type,
          selected: false,
          iconUrl: service.picture_url,
        }));
      } else if (type === 'reports') {
        mappedItems = _.map(items, (report) => ({
          id: report.id,
          description: report.description,
          item_type: report.report_type,
          title: report.report_title,
          account_type: report.account_type,
          selected: false,
          iconUrl: false,
        }));
      } else if (type === 'serviceTypes') {
        mappedItems = _.map(items, (service) => ({
          id: service.id,
          title: service.service_type,
          iconUrl: service.icon_url,
        }));
      } else if (type === 'permissions') {
        mappedItems = _.map(items, (permission, index) => {
          const returnObject = {
            id: permission.id,
            title: permission.profile_name,
          };
          if (index === 0) returnObject.selected = true;
          return returnObject;
        });
      } else if (type === 'lists') {
        mappedItems = _.map(items, (list, index) => {
          const returnObject = {
            id: list.id,
            title: list.list_name,
          };
          if (index === 0) returnObject.selected = true;
          return returnObject;
        });
      } else if (type === 'usersFilter') {
        mappedItems = _.map(items, (item) => ({
          id: item.id,
          title: item.profile_name,
          type: 'permission',
          selected: false,
        }));

        _.each([{
          id: 'Active',
          title: window.lookup('Active'),
          type: 'profile',
        }, {
          id: 'Inactive',
          title: window.lookup('Inactive'),
          type: 'profile',
        }, {
          id: 'trial',
          title: window.lookup('Trial user'),
          type: 'profile',
        }, {
          id: 'Team Member',
          title: window.lookup('Team member'),
          type: 'profile',
        }, {
          id: 'Client',
          title: window.lookup('Client'),
          type: 'profile',
        }, {
          id: 'Administrator',
          title: window.lookup('Administrator'),
          type: 'profile',
        }], (item) => {
          mappedItems.push({
            id: item.id,
            title: item.title,
            type: 'profile',
            selected: false,
          });
        });
      } else if (type === 'mediaLibraries' || type === 'campaigns') {
        mappedItems = _.map(items, (item) => ({
          id: item.id,
          title: item.name,
        }));
      } else {
        mappedItems = _.map(items, (item) => ({
          id: item.id,
          title: item.library_name,
        }));
      }

      return mappedItems;
    },

    formatUsersResult(user) {
      const el = user.element[0];
      const userText = _.escape(user.text);
      return `<span class='user-colors' style='color:${el.getAttribute('data-color')};' >&bull;</span>${userText}` ? userText : '';
    },

    formatUsers(user) {
      const strIcon = ' &nbsp; ';
      const el = user.element[0];
      const userText = _.escape(user.text);
      const hierarchy = el.getAttribute('data-user-hierarchy');

      if (!hierarchy) {
        return userText;
      }
      if (hierarchy > 0) {
        return `${strIcon
        }<img alt='' class='user-avatars user-avatars-small' src='${
          el.getAttribute('data-avatar')}' > <span class='uchild'>${truncate(userText, 20)}</span>`;
      }
      return `<hr><img alt='' class='user-avatars' src='${
        el.getAttribute('data-avatar')}' > <span class='uadmin'>${truncate(userText, 20)}</span>`;
    },
    formatService(service) {
      const el = service.element[0];
      const iconURL = el.getAttribute('data-icon-url');
      const serviceText = _.escape(service.text);
      let imgTag = '';

      if (iconURL) {
        imgTag = `<img alt='' src='${iconURL}' class='service_image' />`;
      }
      return `<span title='${serviceText}'>${imgTag} ${serviceText}<span class='paraEnd'></span></span>`;
    },
  };

  $.fn.makeFilter = function (options) {
    return this.each(function () {
      // eslint-disable-next-line no-new
      new MakeFilter(this, options);
    });
  };
}($));

(function ($) {
  const defaults = {
    step: 1,
    min: 0,
    max: 99999,
    upBtn: '.icon-chevron-right',
    downBtn: '.icon-chevron-left',
  };
  // users | services |
  function Spinner(element, options) {
    const widget = this;
    _.bindAll(this, 'triggerClicked');

    widget.config = $.extend(true, {}, defaults, options);
    widget.element = element;
    element.widget = widget;
    widget.$element = $(element);

    this.checkRange();

    this.counter = parseInt(widget.$element.val(), 10) || widget.config.min;
    this.init();
  }

  Spinner.prototype = {
    init() {
      const that = this;
      let id;
      const $spinner = this.$element;
      const $trigger = $spinner.parent().find('.trigger');

      $trigger.on('click', this.triggerClicked);

      $trigger.on('mousedown', (evt) => {
        id = setTimeout(() => {
          id = setInterval(() => {
            that.triggerClicked(evt);
          }, 10);
        }, 600);
      });

      $trigger.attr('unselectable', 'on')
        .addClass('unselectable').bind('selectstart', () => false);

      $trigger.on('mouseup mouseout', () => {
        clearInterval(id);
        clearTimeout(id);
      });
    },
    checkRange() {
      const widget = this;

      const min = widget.$element.data('min');
      const max = widget.$element.data('max');
      const step = widget.$element.data('step');

      if (typeof min !== 'undefined') {
        widget.config.min = parseInt(min, 10);
      }
      if (typeof max !== 'undefined') {
        widget.config.max = parseInt(max, 10);
      }
      if (typeof step !== 'undefined') {
        widget.config.step = parseInt(step, 10);
      }
    },
    triggerClicked(evt) {
      let val;
      const $target = $(evt.currentTarget);
      const dirIsUp = $target.hasClass('up-step');

      if (dirIsUp) {
        val = this.counter + parseInt(this.config.step, 10);
      } else {
        val = this.counter - parseInt(this.config.step, 10);
      }

      this.setSpinner(val);
    },
    setSpinner(val, silent) {
      this.checkRange();

      if (isNaN(val)) return;

      if (val > this.config.max) {
        this.$element.val(this.config.max);
        this.counter = this.config.max;
      } else if (val < this.config.min) {
        this.$element.val(this.config.min);
        this.counter = this.config.min;
      } else {
        this.$element.val(val);
        this.counter = val;
      }

      if (!silent) {
        this.$element.trigger('change');
      }
    },
  };

  $.fn.spinner = function (options, arg, silent) {
    return this.each(function () {
      if ((options && typeof options === 'object') || !options) {
        // eslint-disable-next-line no-new
        new Spinner(this, options, arg);
      } else if (options && options === 'val') {
        Spinner.prototype.setSpinner.call(this.widget, parseInt(arg, 10), silent);
      }
    });
  };
}($));

export default Object.assign(window.Utils, ObjectUtils, UrlUtils);
